import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import dayjs from 'dayjs';

/**
 * Mock面试流程数据仓库
 * 用于管理模拟的面试流程数据
 */
// 你提供的候选人信息（作为单独变量，便于后续直接复用/对照结构）
// 说明：avatarData 是超长 base64，容易导致仓库体积膨胀，这里用 null 占位；结构字段保持一致。
const mockCandidateResponseTemplate = {
    code: 200,
    msg: '操作成功',
    data: {
        id: '1982700606961041410',
        name: '【示例】张三',
        degree: '本科',
        experienceLevel: '0',
        email: '3425257002@qq.com',
        phoneNumber: '19210306141',
        gender: '2',
        birthDate: '2001-11',
        nativePlace: '',
        idNumber: '',
        experienceDetail: null,
        jobStatus: '0',
        jobStatusDetail: null,
        expectedHireDate: null,
        currentSalary: null,
        expectedSalary: null,
        expectedPosition: null,
        expectedCity: null,
        resumeId: '1982700607015567361',
        resume: {
            id: '1982700607015567361',
            candidateId: '1982700606961041410',
            strength:
                '业务指标：亚马逊实习期间美国站月均销量300+，销售额6万美金，利润20%，物流成本降低10%。项目成果：活动策划提升参与度、品牌评分维护、listing页面优化。团队管理：跨部门协调效率提升、校园活动全流程组织经验。',
            weakness:
                '跨境电商实操经验仅3个月，深度运营能力待验证；英语仅CET4，缺乏高阶商务英语证明；未明确展示数据分析工具（如Excel函数、BI工具）的应用能力。',
            eduAnalysis:
                '华南农业大学为非985/211高校，但属于双一流学科建设高校，国内综合排名约90-120名，具备一定的教育质量基础。',
            comment: null,
            resumePath:
                'https://ita-interview-test.oss-cn-shenzhen.aliyuncs.com/interview/resume/2025/10/27/d332d04b3f6d48a1857311e686a5dba0.pdf',
            fileId: '1982700603903393793',
            fileName: '【跨境电商亚马逊运营专员_深圳_5-10K】纪锐钊_4年.pdf',
            // fileText 很长，这里保留字段即可（不影响结构对齐）
            fileText: "基本信息 姓 名: 纪锐钊 出生年月: 2001.11 民 族: 汉 身 高: 172cm 电 话: 19210306141 政治面貌: 共青团员 邮 箱: 3425257002@qq.com 毕业院校: 华南农业大学 住 址: 深圳 学 历: 本科 教育背景 2020.09 - 2024.07 华南农业大学 园林(本科) 工作经历 2024.02 - 2024.05 广州凡岛网络有限公司 行政实习生 活动策划与执行: 负责公司各类活动的策划与组织实施, 确保活动顺利进行, 有效提升了公司活动的参与度。 考勤管理: 负责公司员工的日常考勤记录, 确保考勤数据的准确性和及时性。 行政支持: 负责公司人员工作牌、座位牌的制作与管理, 以及公司大小会议的布置工作。 跨部门协调: 与其他部门紧密合作, 协调完成各类工作任务, 提升团队的协作效率。 2025.03 - 2025.06 广州瑞赢互联投资有限公司 亚马逊运营实习生 SKU运营管理: 负责美国站点与欧洲站点FBA、主营收纳类目(珠宝盒、首饰盒、手表盒), 协助运营专员进行店铺所有SKU的运营管理。产品单价在50 - 200美金, 美国站的月均销售量300 +, 销售额达6万美金以上, 利润约20 %。 日常管理: 负责美国站点产品定价、上架、维护和listing页面优化, 时刻监督账户相关数据, 确保账户安全。 需求对接: 依据运营专员下达的任务, 沟通对接产品需求(如产品主图、A +、视频等)。 物流对接: 熟悉FBA发货, 对接货代公司, 多方询价降低物流成本10 %; 及时处理每周发货, 数据记录, 物流情况及时更新, 对接供应商协调发货, 打印标签, 上传箱贴。 品牌建设: 负责协助品牌建设, 维护店铺评分, 提高客户满意度。处理客户退换货和退款申请, 推动产品优化与改进 校园经历 2021.10 - 2022.06 华南农业大学青年志愿者服务中心 培训部干员 负责青年志愿者培训会的会议主持工作; 负责会议前的准备工作: 撰写会议主持稿, 布置会议现场, 统计参会人员, 调试电脑、投影仪、音响、话筒等设备; 组织多场志愿者活动, 从活动的策划, 人员调配到活动的落地。 专业技能 语言能力: 大学英语4级证书, 有良好的英语听说读写和翻译能力。 计算机: 熟练操作windows平台上的各类应用软件, 如Word、Excel、PS、CAD等; 自我评价 本人具备良好的学习能力和团队协作精神, 能够迅速适应新环境和新任务。在实习和校园活动中积累了丰富的实践经验, 具备较强的责任心和执行力。期待在未来的工作中, 能够发挥自己的专业优势和技能特长, 为公司的发展贡献自己的力量。",
            tags: null,
            questions: [
                { id: '1982700833864499201', resumeId: '1982700607015567361', content: '请具体说明FBA发货中降低物流成本10%的实施方案', useFlag: 0 },
                { id: '1982700833872887810', resumeId: '1982700607015567361', content: '如何处理价值200美金产品的客诉升级事件？', useFlag: 0 },
                { id: '1982700833872887811', resumeId: '1982700607015567361', content: '请演示你用数据驱动listing优化的完整流程', useFlag: 0 },
                { id: '1982700833877082114', resumeId: '1982700607015567361', content: '当运营策略与设计部门产出冲突时如何协调？', useFlag: 0 },
                { id: '1982700833877082115', resumeId: '1982700607015567361', content: '你日常监控哪些关键指标来保障账户安全？', useFlag: 0 },
                { id: '1982700833881276418', resumeId: '1982700607015567361', content: '针对差评率上升会采取哪些具体行动？', useFlag: 0 },
                { id: '1982700833885470721', resumeId: '1982700607015567361', content: '如果新品推广预算缩减30%如何调整策略？', useFlag: 0 },
                { id: '1982700833889665026', resumeId: '1982700607015567361', content: '你的职业规划与跨境电商行业的匹配点是什么？', useFlag: 0 },
            ],
            potential:
                '从行政到跨境电商的跨领域适应显示强学习能力，产品全链路操作经验为其向资深亚马逊运营、跨境品牌管理岗位发展奠定基础。',
            gapAnalysis:
                '2024.07毕业至2025.03存在8个月空窗期（简历未覆盖），需核查求职/备考情况；2024.05-2025.03实习间隔期间职业规划连续性待确认。',
            jobHopAnalysis:
                '实习周期均为3-4个月（符合学生身份），但需关注正式工作后的稳定性预期，暂无跳槽记录。',
        },
        educations: [
            {
                id: '1982700607204311041',
                candidateId: '1982700606961041410',
                institution: '华南农业大学',
                degree: '本科',
                major: '园林',
                startDate: '2020-09',
                endDate: '2024-07',
                educationDescription: null,
                institutionType: '0',
                institutionRank: '101',
                institutionGlobalRank: null,
            },
        ],
        workExperiences: [
            {
                id: '1982700607145590786',
                candidateId: '1982700606961041410',
                companyName: '广州瑞赢互联投资有限公司',
                startDate: '2025-03',
                endDate: '2025-06',
                jobTitle: '亚马逊运营实习生',
                salary: null,
                department: null,
                jobDescription:
                    'SKU运营管理:负责美国站点与欧洲站点FBA、主营收纳类目(珠宝盒、首饰盒、手表盒),协助运营专员进行店\n铺所有SKU的运营管理。产品单价在50-200美金,美国站的月均销售量300+,销售额达6万美金以上,利润约\n20%。\n日常管理:负责美国站点产品定价、上架、维护和listing页面优化,时刻监督账户相关数据,确保账户安全。\n需求对接:依据运营专员下达的任务,沟通对接产品需求(如产品主图、A+、视频等)。\n物流对接:熟悉FBA发货,对接货代公司,多方询价降低物流成本10%;及时处理每周发货,数据记录,物流情况\n及时更新,对接供应商协调发货,打印标签,上传箱贴。\n品牌建设:负责协助品牌建设,维护店铺评分,提高客户满意度。处理客户退换货和退款申请,推动产品优化与\n改进',
                jobAchievements: null,
            },
            {
                id: '1982700607162368002',
                candidateId: '1982700606961041410',
                companyName: '广州凡岛网络有限公司',
                startDate: '2024-02',
                endDate: '2024-05',
                jobTitle: '行政实习生',
                salary: null,
                department: null,
                jobDescription:
                    '活动策划与执行:负责公司各类活动的策划与组织实施,确保活动顺利进行,有效提升了公司活动的参与度。\n考勤管理:负责公司员工的日常考勤记录,确保考勤数据的准确性和及时性。\n行政支持:负责公司人员工作牌、座位牌的制作与管理,以及公司大小会议的布置工作。\n跨部门协调:与其他部门紧密合作,协调完成各类工作任务,提升团队的协作效率。',
                jobAchievements: null,
            },
        ],
        projects: [],
        jobPreference: {
            id: '1982700607233671170',
            candidateId: '1982700606961041410',
            expectedJobTitle: null,
            expectedSalary: null,
            expectedLocation: null,
            expectedHireDate: null,
        },
        certifications: [{ id: '1982700607263031298', certificationName: '大学英语4级', candidateId: '1982700606961041410' }],
        skills: [
            { id: '1982700607292391425', skillName: 'PS', candidateId: '1982700606961041410' },
            { id: '1982700607300780034', skillName: '翻译', candidateId: '1982700606961041410' },
            { id: '1982700607300780035', skillName: '英语听说', candidateId: '1982700606961041410' },
            { id: '1982700607304974338', skillName: 'listing', candidateId: '1982700606961041410' },
            { id: '1982700607309168642', skillName: 'FBA发货', candidateId: '1982700606961041410' },
            { id: '1982700607313362946', skillName: '亚马逊运营', candidateId: '1982700606961041410' },
            { id: '1982700607317557250', skillName: 'FBA', candidateId: '1982700606961041410' },
            { id: '1982700607317557251', skillName: '账户安全', candidateId: '1982700606961041410' },
        ],
        positionId: '1828669103013834753',
        recruitmentId: '1982653981475430401',
        profileId: '1982654320513605633',
        profile: null,
        remark: null,
        wechat: null,
        process: null,
        archived: '1',
        readFlag: '1',
        resignReason: null,
        score: 80.0,
        resumeScore: 47.7,
        processStatus: 1,
        recruitmentStatus: 5,
        tags: [
            { id: '1897837049931911169', name: '大学英语4级', positionId: null, required: '1', sysId: null },
            { id: '1982700607535661058', name: '亚马逊运营实习生', positionId: null, required: '1', sysId: null },
        ],
        content: null,
        position: '产品岗',
        remarkCount: 0,
        talentSource: 1,
        talentTagVos: null,
        createBy: '1973600648893194241',
        creator: {
            userId: '1973600648893194241',
            nickName: '魏景媛',
            deptId: '2010661543026692097',
            deptName: '产品与洞察部',
            tenantId: '096274',
            userName: '17701274002',
            userType: 'sys_user',
            email: '',
            phonenumber: '17701274002',
            sex: '2',
            avatar: null,
            status: '0',
            loginIp: '113.110.215.17',
            loginDate: '2026-01-19 14:11:14',
            remark: null,
            createTime: '2025-10-02 12:07:17',
            roles: [
                {
                    roleId: '1828315447489536001',
                    roleName: '公司管理员',
                    roleKey: 'admin',
                    roleSort: 1,
                    dataScope: '1',
                    menuCheckStrictly: null,
                    deptCheckStrictly: null,
                    status: '0',
                    remark: null,
                    createTime: null,
                    flag: false,
                    editable: 0,
                    superAdmin: false,
                },
            ],
            roleIds: null,
            postIds: null,
            roleId: null,
        },
        createTime: '2025-10-27 14:47:16',
        isCollect: 0,
        candidateGroups: null,
        avatarData: null,
        avatarUrl: null,
        age: 24,
        currentAddress: '中国-广东省-深圳市',
        workStatus: '',
        externalContacts: [],
        duplicateCandidates: [],
        valid: '1',
        candidateScreening: null,
        candidateAnalysis: null,
    },
};

// 面试内容列表 mock 数据（按节点ID组织）
const interviewContentList = [{
    nodeId: "-1000000027",
    rows: [
        {
            "id": "2013126472395644930",
            "speakerId": 0,
            "speakerName": null,
            "content": "看到你在瑞盈负责收纳类产品从上线到稳定销售整个周期里最大的挑战是什么？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 1
        },
        {
            "id": "2013126472513085442",
            "speakerId": 0,
            "speakerName": null,
            "content": "当时是怎么判断一个产品该继续投入还是应该砍掉的？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 2
        },
        {
            "id": "2013126472534056962",
            "speakerId": 1,
            "speakerName": null,
            "content": "在瑞银负责收纳类产品时，整个周期里最大的挑战是新品上线后第三周遇到的流量断层。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 3
        },
        {
            "id": "2013126472576000002",
            "speakerId": 1,
            "speakerName": null,
            "content": "当时listing优化和基础广告都做了，但自然排名卡在类目300名左右，广告ac高达42%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 4
        },
        {
            "id": "2013126472609554433",
            "speakerId": 1,
            "speakerName": null,
            "content": "每天只有2到3单，处于食之无味、弃之可惜的尴尬状态。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 5
        },
        {
            "id": "2013126472651497474",
            "speakerId": 1,
            "speakerName": null,
            "content": "至于判断产品该继续投入还是砍掉，我不是凭感觉，而是靠三个核心数据维度加一个观察周期的量化标准来决策。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 6
        },
        {
            "id": "2013126472680857602",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体如下，一核心数据维度，一点击率ctr加转化率cv 2是否达标。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 7
        },
        {
            "id": "2013126472714412034",
            "speakerId": 1,
            "speakerName": null,
            "content": "先对比收纳类目平均数据，当时类目ctr均值2.8%，cv 2均值4.5%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 8
        },
        {
            "id": "2013126472747966465",
            "speakerId": 1,
            "speakerName": null,
            "content": "我们这款收纳盒的ctr能达到3.2%，cv 2能达到5.1%，两项数据都高于类目均值，这说明listing的主图标题价格是被买家认可的，问题不出在转化端，而是流量曝光不足，值得再推一把。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 9
        },
        {
            "id": "2013126472785715201",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果这两项数据持续低于类目均值的80%，且优化后无改善，就说明产品本身不被市场接受，建议直接砍掉。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 10
        },
        {
            "id": "2013126472819269633",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、核心数据维度2、广告测试的核心关键词排名是否有上升潜力？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 11
        },
        {
            "id": "2013126472848629762",
            "speakerId": 1,
            "speakerName": null,
            "content": "我选取了十个核心长尾词，比如under back storage box with late foldable closet organizer做精准广告测试，观察七天后发现有六个词的广告排名从20名外冲进了前十名，且点击成本cpc从0.8美元降到了0.5美元。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 12
        },
        {
            "id": "2013126472882184193",
            "speakerId": 1,
            "speakerName": null,
            "content": "这说明关键词的相关性和竞争力是有的，只是需要调整广告策略，放大流量。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 13
        },
        {
            "id": "2013126472915738626",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果核心词连续14天排名毫无波动，且cpc远超类目均值，就没必要继续投广告。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 14
        },
        {
            "id": "2013126472953487361",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、核心数据维度3、退货率加差评率是否在可控范围？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 15
        },
        {
            "id": "2013126472991236098",
            "speakerId": 1,
            "speakerName": null,
            "content": "这款产品的退货率稳定在2.3%，差评率1.1%，且差评集中在包装有点薄，不是产品功能硬伤，这说明产品质量和用户体验没有大问题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 16
        },
        {
            "id": "2013126473020596225",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果退货率超过8%，且差评多是容量不符、材质易破等核心功能问题，就建议弹掉，避免影响店铺欧Dr二指标观察周期。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 17
        },
        {
            "id": "2013126473054150658",
            "speakerId": 1,
            "speakerName": null,
            "content": "我给这类新品设置的是两个自然周的冲刺观察期，在这个周期里我调整了广告策略，暂停广泛广告，把预算集中到那六个有潜力的核心长尾词上。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 18
        },
        {
            "id": "2013126473083510785",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时优化了包装加厚快递袋，并在listing里突出加固包装卖点。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 19
        },
        {
            "id": "2013126473117065217",
            "speakerId": 1,
            "speakerName": null,
            "content": "还申请了亚马逊的lightning deal小秒杀，结果冲刺期第十天自然排名冲到了内部86名，广告a co降到了21%，日单量稳定在15到20单，后续逐步成为店铺的稳定款。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 20
        },
        {
            "id": "2013126473154813954",
            "speakerId": 1,
            "speakerName": null,
            "content": "总结下来，我的判断逻辑很简单，只要点击率加转化率达标，加核心词有排名潜力，加品控无硬伤，就值得继续投入，反之，任意核心维度持续不达标且优化无效，就果断砍掉止损。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 21
        },
        {
            "id": "2013126473184174082",
            "speakerId": 0,
            "speakerName": null,
            "content": "如果现在让你从零开始推一个新品，你会怎么规划前三个月的关键节点？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 22
        },
        {
            "id": "2013126473217728514",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果让我从零开始推一款亚马逊收纳类新品。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 23
        },
        {
            "id": "2013126473242894337",
            "speakerId": 1,
            "speakerName": null,
            "content": "前三个月会按冷启动期、增长爬坡期、稳定放量期三个阶段划分关键节点，每个阶段聚焦核心目标，用数据驱动动作。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 24
        },
        {
            "id": "2013126473276448770",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体规划如下，第一阶段第1到2周冷启动期，夯实基础，精准测款核心目标完成listing精细化搭建加关键词测试加初始评价积累，避免无效曝光。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 25
        },
        {
            "id": "2013126473305808898",
            "speakerId": 1,
            "speakerName": null,
            "content": "一关键动作一，第1到3天市场调研加listing精准搭建，扒取to p 20竞品的差评痛点。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 26
        },
        {
            "id": "2013126473339363329",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如收纳盒承重差折叠后有折痕，结合自家产品优势，把核心卖点如承重20斤无痕折叠埋入标题前60字符。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 27
        },
        {
            "id": "2013126473372917761",
            "speakerId": 1,
            "speakerName": null,
            "content": "五点描述首条主图，首图突出场景化使用，比如衣柜分层收纳实拍附图补充细节承重测试折叠对比A加页面做竞品对比表，强化差异化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 28
        },
        {
            "id": "2013126473410666498",
            "speakerId": 1,
            "speakerName": null,
            "content": "二关键动作二第4到7天长尾词精准广告测试，筛选50个低竞争长尾词，搜索量500到2000，竞争度小于0点千分。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 29
        },
        {
            "id": "2013126473444220930",
            "speakerId": 1,
            "speakerName": null,
            "content": "三个广告组精准匹配小预算投放，每日预算控制在20到30美元。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 30
        },
        {
            "id": "2013126473473581057",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时开启自动广告，目的是抓取买家真实搜索词，而非放量。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 31
        },
        {
            "id": "2013126473502941185",
            "speakerId": 1,
            "speakerName": null,
            "content": "三关键动作三第8到14天合规积累初始评价，通过亚马逊早期评论人计划1P2加Y计划，适合有品牌备案的产品获取5到10条真实评价，同步联系老客户做小额折扣换屏。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 32
        },
        {
            "id": "2013126473536495618",
            "speakerId": 1,
            "speakerName": null,
            "content": "严格遵守亚马逊合规政策不锁屏，确保新品有基础评价支撑。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 33
        },
        {
            "id": "2013126473570050049",
            "speakerId": 1,
            "speakerName": null,
            "content": "转化节点验收标准，listing cp R大于等于类目增值的1.1倍，c率R大于等于类目均值。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 34
        },
        {
            "id": "2013126473599410177",
            "speakerId": 1,
            "speakerName": null,
            "content": "广告组里至少十个长尾词，有稳定曝光和点击。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 35
        },
        {
            "id": "2013126473632964610",
            "speakerId": 1,
            "speakerName": null,
            "content": "第二阶段，第3到8周增长爬坡期，放大流量优化，转化核心目标，提升核心关键词排名，降低a course，实现日单量稳步增长。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 36
        },
        {
            "id": "2013126473666519042",
            "speakerId": 1,
            "speakerName": null,
            "content": "一关键动作一，第3到4周广告策略迭代，聚焦高转化词，关停无点击、无转化的长尾词，把运算集中到cpr大于3%、cpr大于5%的优质词上，针对核心词如underback storage box适当评价，冲击前十名排名，同时开启关联广告，绑定竞品asn获取关联流量。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 37
        },
        {
            "id": "2013126473700073473",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、关键动作2，第5到6周，优化listing短板，提升转化效率，分析差评和Q A针对性优化，比如差评反馈尺寸偏小，就在listing首图和五点描述里加粗，标注具体尺寸。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 38
        },
        {
            "id": "2013126473729433602",
            "speakerId": 1,
            "speakerName": null,
            "content": "Qa板块主动布局高频问题，如是否适合放毛衣，降低买家决策成本。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 39
        },
        {
            "id": "2013126473767182338",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、关键动作3，第7到8周申报平台活动冲刺流量高峰申报7杯de或秒杀lightning deal活动前三天优化listing和广告，活动期间加大广告预算冲击类目排名活动后复盘数据评估活动对自然排名的带动效果，节点验收标准核心词自然排名进入类目前50广告accourse控制在25%以内，日单量稳定在15到20单。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 40
        },
        {
            "id": "2013126473800736769",
            "speakerId": 1,
            "speakerName": null,
            "content": "退货率小于3%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 41
        },
        {
            "id": "2013126473830096897",
            "speakerId": 1,
            "speakerName": null,
            "content": "第三阶段第9到12周稳定放量期，维稳增效，打造小爆款核心目标，提升自然流量占比，降低广告依赖，实现利润最大化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 42
        },
        {
            "id": "2013126473859457025",
            "speakerId": 1,
            "speakerName": null,
            "content": "一关键动作一第9到10周内容营销撬动自然流量，每周发布三条亚马逊pos内容，为产品不同场景的使用实拍，衣柜、床底、阳台收纳联系5到8个粉丝量5000到10千的家居类微网红做真实测评，挂产品链接引流。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 43
        },
        {
            "id": "2013126473897205761",
            "speakerId": 1,
            "speakerName": null,
            "content": "二关键动作2，第11到12周，优化库存与供应链，降低成本。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 44
        },
        {
            "id": "2013126473930760193",
            "speakerId": 1,
            "speakerName": null,
            "content": "根据前八周的销售数据计算安全库存周期，建议6到8周避免断货或库存积压，和供应商谈判，争取批量采购折扣，降低产品成本，提升利润率。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 45
        },
        {
            "id": "2013126473964314626",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、关键动作3，第12周复盘数据制定长期维稳策略。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 46
        },
        {
            "id": "2013126473997869058",
            "speakerId": 1,
            "speakerName": null,
            "content": "统计三个月的核心数据，自然流量占比、复购率、利润率。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 47
        },
        {
            "id": "2013126474039812098",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果自然流量占比大于60%，利润率大于等于20%，就纳入店铺核心主推款。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 48
        },
        {
            "id": "2013126474077560833",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果数据未达标，分析是流量还是转化问题，制定下一季度优化方案节点验收标准，自然流量占比大于等于60%，绿单量稳定在30家，利润率大于等于20%，店铺该品类关联销售占比提升10%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 49
        },
        {
            "id": "2013126474106920961",
            "speakerId": 1,
            "speakerName": null,
            "content": "整个三个月的规划核心是先精准测款，再逐步放量，最后维稳增效。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 50
        },
        {
            "id": "2013126474140475394",
            "speakerId": 1,
            "speakerName": null,
            "content": "每个阶段都有明确的验收标准，避免盲目投入。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 51
        },
        {
            "id": "2013126474174029825",
            "speakerId": 1,
            "speakerName": null,
            "content": "需要我为你整理这份规划对应的和。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 52
        },
        {
            "id": "2013126474207584257",
            "speakerId": 0,
            "speakerName": null,
            "content": "你刚才详细阐述了新品上架前三个月的完整规划，思路非常清晰。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 53
        },
        {
            "id": "2013126474241138689",
            "speakerId": 0,
            "speakerName": null,
            "content": "现在我们聊一聊亚马逊平台日常运营中的另一个重要环节。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 54
        },
        {
            "id": "2013126474274693121",
            "speakerId": 0,
            "speakerName": null,
            "content": "在产品进入稳定销售后，库存与fba管理变得尤为关键。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 55
        },
        {
            "id": "2013126474308247553",
            "speakerId": 0,
            "speakerName": null,
            "content": "你是如何制定补货计划以及处理可能出现的库存积压或断货风险的？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 56
        },
        {
            "id": "2013126474337607682",
            "speakerId": 1,
            "speakerName": null,
            "content": "在产品稳定销售阶段，不制定补货计划的核心逻辑是数据驱动的安全库存模型加供应链弹性预留，而处理库存积压和断货风险则是基于提前预警加针对性干预的策略。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 57
        },
        {
            "id": "2013126474371162113",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体操作如下，一、制定fba补货计划的核心步骤一、第一步，搭建基础数据模型，确定核心参数，先统计三组核心数据，日均销量ad s取稳定期28天的平均销量，剔除秒杀促销的异常峰值，避免高估需求。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 58
        },
        {
            "id": "2013126474404716545",
            "speakerId": 1,
            "speakerName": null,
            "content": "补货周期lt包含供应商生产时间加头程物流时间加fba入库上架时间，比如生产七天加海运30天，加上架五天，总补货周期就是42天。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 59
        },
        {
            "id": "2013126474434076674",
            "speakerId": 1,
            "speakerName": null,
            "content": "安全库存天数ss按淡旺季调整，淡季设15天，应对物流小幅延迟，旺季设30天应对亚马逊爆仓物流拥堵，再套用公式计算补货量，补货量等于日均销量乘补货周期加安全库存天数，现有fba库存减在途库存。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 60
        },
        {
            "id": "2013126474467631106",
            "speakerId": 1,
            "speakerName": null,
            "content": "举个例子，收纳盒日均销量二十单，补货周期42天，安全库存15天，现有库存五百单，在途库存0，则补货量等于20乘括号42加15括回减500等于640单。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 61
        },
        {
            "id": "2013126474496991234",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、第二步分淡旺季动态调整，预留弹性空间，淡季按基础公式补货，同时设置库存上限，比如不超过日均销量乘60天，避免积压旺季。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 62
        },
        {
            "id": "2013126474526351361",
            "speakerId": 1,
            "speakerName": null,
            "content": "黑五网易Priday提前两个月和供应商锁定产能，补货量上浮20%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 63
        },
        {
            "id": "2013126474555711489",
            "speakerId": 1,
            "speakerName": null,
            "content": "头城物流预留海运加空派双通道，海运走主力货量，空派被10%应急库存，防止海运延误导致断货。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 64
        },
        {
            "id": "2013126474593460226",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、第三步，建立库存监控看板，每周复盘调整，用excel或第三方工具如领星积加搭建看板，实时监控现有库存可售天数、在图库存进度、fba入库时效，每周对比实际销量和预估销量的偏差，若偏差超过10%，则在下一次补货时修正日均销量参数。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 65
        },
        {
            "id": "2013126474627014657",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、处理断货风险的提前预警与干预策略。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 66
        },
        {
            "id": "2013126474656374786",
            "speakerId": 1,
            "speakerName": null,
            "content": "断货的核心危害使关键词排名下滑，listing权重降低，所以关键是避免完全断货，加快速恢复库存。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 67
        },
        {
            "id": "2013126474845118466",
            "speakerId": 1,
            "speakerName": null,
            "content": "一、提前预警，设置库存预警线，当可售天数低于安全库存天数时，立刻启动应急方案。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 68
        },
        {
            "id": "2013126474891255809",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、应急干预措施，若头程物流延误，紧急调拨同仓库的其他sku库存，支援或切换头程物流方式。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 69
        },
        {
            "id": "2013126474924810242",
            "speakerId": 1,
            "speakerName": null,
            "content": "海运改空态，哪怕成本高也要保住listing排名，若sba库存即将售罄，开启预售模式，亚马逊后台设置，同时在listing详情页注明补货时间，引导买家下单断货后补救。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 70
        },
        {
            "id": "2013126474954170369",
            "speakerId": 1,
            "speakerName": null,
            "content": "上架后第一时间开启精准广告投放，核心关键词快速拉升排名，同时配合小额优惠券刺激转化，弥补断货期间的权重损失。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 71
        },
        {
            "id": "2013126474987724802",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、处理库存积压的轻库存策略。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 72
        },
        {
            "id": "2013126475021279234",
            "speakerId": 1,
            "speakerName": null,
            "content": "库存积压的核心是去库存，加控损失，优先保证现金流而非利润。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 73
        },
        {
            "id": "2013126475050639361",
            "speakerId": 1,
            "speakerName": null,
            "content": "一、第一步，判断积压类型，针对性施策。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 74
        },
        {
            "id": "2013126475084193793",
            "speakerId": 1,
            "speakerName": null,
            "content": "若为季节性积压，比如夏季收纳盒冬季滞销，设置长期折扣降价10%到15%，同时捆绑搭配销售，如收纳盒加衣架组合优惠转移到旺季前清完。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 75
        },
        {
            "id": "2013126475117748225",
            "speakerId": 1,
            "speakerName": null,
            "content": "若为非季节性积压，比如产品竞争力下降，一先优化listing主图五点描述，投放长尾精准广告，尝试激活。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 76
        },
        {
            "id": "2013126475151302658",
            "speakerId": 1,
            "speakerName": null,
            "content": "若优化无效，立刻通过亚马逊outlet Ste清仓或站外找折扣网站如ck de发帖降价30%到50%，快速出清，避免产生长期仓储费。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 77
        },
        {
            "id": "2013126475180662786",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、最后兜底方案，申请移除库存，运回国内转卖其他平台如淘宝、拼多多，减少损失。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 78
        },
        {
            "id": "2013126475214217218",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、第二步，规避后续积压，优化补货机制，积压后复盘预估销量偏差原因，比如是误判旺季需求，还是产品竞争力下降，然后调整补货模型中的日均销量、安全库存天数等参数，同时对滞销sku降低补货优先级，甚至暂停补货。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 79
        },
        {
            "id": "2013126475247771650",
            "speakerId": 0,
            "speakerName": null,
            "content": "如果现在给你一个全新的产品类目，你会从哪些数据维度开始分析？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 80
        },
        {
            "id": "2013126475281326082",
            "speakerId": 1,
            "speakerName": null,
            "content": "面对全新的产品类目，我会从市场容量、竞争格局、用户需求、利润空间四个核心维度切入，用数据验证类目可行性，避免盲目入场。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 81
        },
        {
            "id": "2013126475314880514",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体分析维度如下，一、市场容量维度判断类目值不值得做，核心看三个数据，一是类目整体销量趋势，用卖家精灵k时查近六个月类目销量的环比增长率，优先选增长率大于等于10%的上升期类目，避开负增长的萎缩类目。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 82
        },
        {
            "id": "2013126475344240642",
            "speakerId": 1,
            "speakerName": null,
            "content": "二是to p 100商品的日均总销量，总销量越高说明市场需求越大。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 83
        },
        {
            "id": "2013126475377795073",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如日均总销量大于等于5000单的类目比日均1000单的类目更有操作空间。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 84
        },
        {
            "id": "2013126475407155202",
            "speakerId": 1,
            "speakerName": null,
            "content": "三是新品进入门槛，统计to p 100里新品上架小于等于6个月的占比，占比大于等于20%，说明类目对新品友好有突围机会。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 85
        },
        {
            "id": "2013126475440709633",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、竞争格局维度，判断能不能打得过，重点分析竞争激烈程度和对手实力。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 86
        },
        {
            "id": "2013126475474264065",
            "speakerId": 1,
            "speakerName": null,
            "content": "一是头部垄断情况，计算套十商品的销量占比，占比小于等于50%，说明类目竞争分散，新品有机会。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 87
        },
        {
            "id": "2013126475503624193",
            "speakerId": 1,
            "speakerName": null,
            "content": "若占比大于等于80%，则头部品牌垄断严重，不建议入场。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 88
        },
        {
            "id": "2013126475537178626",
            "speakerId": 1,
            "speakerName": null,
            "content": "二是竞品核心指标，拉取to p 20竞品的定价区间评分星级评论数，若竞品普遍是4.5星以上加评论数大于等于1000，说明用户口碑壁垒高，新品需要在差异化上做文章。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 89
        },
        {
            "id": "2013126475570733057",
            "speakerId": 1,
            "speakerName": null,
            "content": "三是广告竞争成本，查类目核心关键词的cpc均值cpc过高，比如超过5美元会压缩利润空间，需谨慎评估。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 90
        },
        {
            "id": "2013126475600093185",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、用户需求维度判断做什么样的产品，核心是挖掘用户痛点，指导产品和listing优化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 91
        },
        {
            "id": "2013126475633647617",
            "speakerId": 1,
            "speakerName": null,
            "content": "一是竞品差评分析，批量抓取to p 50竞品的1到3星差评统计高频吐槽点，比如收纳类目常见的承重差，安装复杂，这些就是新品的差异化机会。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 92
        },
        {
            "id": "2013126475667202050",
            "speakerId": 1,
            "speakerName": null,
            "content": "二是买家搜索词分析，筛选出类目下搜索量增长快的长尾词，比如从普通收纳盒到可折叠衣柜收纳盒，这些词背后是用户的细分需求。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 93
        },
        {
            "id": "2013126475696562178",
            "speakerId": 1,
            "speakerName": null,
            "content": "三是qa高频问题，整理竞品区为里的to p 20问题，把对应的解决方案写进listing五点描述，降低买家决策成本。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 94
        },
        {
            "id": "2013126475725922305",
            "speakerId": 1,
            "speakerName": null,
            "content": "四利润空间维度，判断赚不赚钱，这是决定类目是否入场的关键核心。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 95
        },
        {
            "id": "2013126475759476737",
            "speakerId": 1,
            "speakerName": null,
            "content": "算清利润公式，单件利润等于售价，减产品成本、减头程物流费、减fba费用、减广告费、减平台佣金。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 96
        },
        {
            "id": "2013126475788836865",
            "speakerId": 1,
            "speakerName": null,
            "content": "重点验证两个数据，一是类目平均利润率，若行业平均利润率大于等于20%，说明有盈利空间。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 97
        },
        {
            "id": "2013126475818196993",
            "speakerId": 1,
            "speakerName": null,
            "content": "二是成本结构占比，fba费用加广告费的占比最好小于等于售价的30%，否则利润会被大幅压缩。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 98
        },
        {
            "id": "2013126475851751425",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时还要核算资金周转周期，周转周期越短，资金利用率越高，风险越低。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 99
        },
        {
            "id": "2013126475885305858",
            "speakerId": 1,
            "speakerName": null,
            "content": "整个分析过程会形成一份类目可行性分析报告，只有四个维度的数据都达标，才会建议进入该类目任意维度存在明显短板，都会针对性调整产品策略或直接放弃。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 100
        },
        {
            "id": "2013126475918860290",
            "speakerId": 0,
            "speakerName": null,
            "content": "你提到了竞品核心指标，包括定价、星级评论数来都行哦行。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 101
        },
        {
            "id": "2013126475948220417",
            "speakerId": 0,
            "speakerName": null,
            "content": "如果竞品普遍是4.5星以上，且评论数大于1000，这通常意味着什么？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 102
        },
        {
            "id": "2013126475977580545",
            "speakerId": 0,
            "speakerName": null,
            "content": "你会如何根据这些数据来制定自己的产品差异策略或进入策略？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 103
        },
        {
            "id": "2013126476011134977",
            "speakerId": 1,
            "speakerName": null,
            "content": "竞品普遍达到4.5星以上，加评论数超1000。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 104
        },
        {
            "id": "2013126476040495105",
            "speakerId": 1,
            "speakerName": null,
            "content": "这意味着两个核心结论，一是该类目用户需求稳定且成熟，买家对产品品质和体验的要求极高。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 105
        },
        {
            "id": "2013126476074049538",
            "speakerId": 1,
            "speakerName": null,
            "content": "二是头部竞品已经建立了牢固的口碑壁垒，新品直接正面竞争难度很大，盲目入场容易被淹没。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 106
        },
        {
            "id": "2013126476103409666",
            "speakerId": 1,
            "speakerName": null,
            "content": "基于这个数据，我会制定差异化切入加精准细分的进入策略，具体分两步走，一、第一步，深挖竞品差评，锁定细分痛点，做产品差异化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 107
        },
        {
            "id": "2013126476136964097",
            "speakerId": 1,
            "speakerName": null,
            "content": "批量抓取po 20竞品的1到3星差评统计高频吐槽点，比如收纳类目里，竞品普遍被吐槽尺寸不适合小衣柜，折叠后有折痕、无分类隔层。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 108
        },
        {
            "id": "2013126476170518530",
            "speakerId": 1,
            "speakerName": null,
            "content": "针对这些未被满足的痛点，打造细分款产品，比如推出迷你款衣柜收纳盒，适配小户型无痕折叠收纳盒、优化材质带可拆卸隔层的收纳盒，满足分类需求。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 109
        },
        {
            "id": "2013126476204072961",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时在listing中直接对标竞品痛点，比如标题写mini under closet storage box for small spaces，古典描述第一条就点名告别普通收纳盒尺寸过大的烦恼，完美适配深度小于40厘米的小衣柜，让买家一眼看到差异化价值。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 110
        },
        {
            "id": "2013126476233433090",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、第二步，避开头，顾红海竞争，走长尾流量加精准场景的入场路径，不直接竞争竞品的核心大词，比如storage box，而是聚焦细分场景的长尾词，比如mini storage box for socks、storage box with dividers for ma这类词竞争度低，转化精准，且买家对价格敏感度更低，广告投放上优先开精准匹配的长尾词，广告组预算控制在小范围，用da co快速积累初始评价。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 111
        },
        {
            "id": "2013126476266987521",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时利用亚马逊po和a加页面，突出细分场景的使用实拍，比如袜子分类收纳、化妆品分区收纳、强化用户认知等。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 112
        },
        {
            "id": "2013126476296347649",
            "speakerId": 1,
            "speakerName": null,
            "content": "积累到300家评论星级稳定在4.5星后再逐步拓展核心词的流量，慢慢向内幕主流市场渗透，而不是一上来就和头部竞品硬碰硬。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 113
        },
        {
            "id": "2013126476329902082",
            "speakerId": 1,
            "speakerName": null,
            "content": "总结来说，面对高口碑壁垒的竞品，新品的核心策略不是更好，而是不同，通过产品和流量的双重差异化，在细分市场站稳脚跟，再伺机扩大份额，需要我为你梳理一份细分痛点挖掘的实操步骤吗？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 114
        },
        {
            "id": "2013126476359262210",
            "speakerId": 0,
            "speakerName": null,
            "content": "需要。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 115
        },
        {
            "id": "2013126476392816641",
            "speakerId": 1,
            "speakerName": null,
            "content": "细分痛点，挖掘实操步骤。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 116
        },
        {
            "id": "2013126476422176769",
            "speakerId": 1,
            "speakerName": null,
            "content": "这个步骤核心是从竞品差评中提炼可落地的产品差异化点，全程用数据说话，避免主观判断。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 117
        },
        {
            "id": "2013126476455731202",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体分为五步，一第一步圈定样本范围，确保数据代表性。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 118
        },
        {
            "id": "2013126476489285634",
            "speakerId": 1,
            "speakerName": null,
            "content": "选取类目to p 20的竞品，优先评论数1000加星级4.5加的头部款。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 119
        },
        {
            "id": "2013126476522840066",
            "speakerId": 1,
            "speakerName": null,
            "content": "每个竞品抓取近三个月的1到3星差评，至少收集200条有效差评。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 120
        },
        {
            "id": "2013126476556394497",
            "speakerId": 1,
            "speakerName": null,
            "content": "差评太少不具备参考性工具推荐用耶力影石卖家经营的差评抓取功能，或手动复制亚马逊详情页的差评内容，整理到excel表格中。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 121
        },
        {
            "id": "2013126476585754626",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、第二步，差评标签化，分类统计高频痛点，对收集的差评做关键词标签归类。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 122
        },
        {
            "id": "2013126476619309058",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如收纳类目常见标签尺寸不符、承重差、折叠有折痕，安装复杂、材质太薄、无分类隔层等。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 123
        },
        {
            "id": "2013126476652863489",
            "speakerId": 1,
            "speakerName": null,
            "content": "统计每个标签的出现频次，计算痛点占比，比如尺寸不符出现40次，总差评200条，占比20%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 124
        },
        {
            "id": "2013126476682223618",
            "speakerId": 1,
            "speakerName": null,
            "content": "筛选出占比大于等于10%的高频痛点，这些就是用户最在意的核心不满点。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 125
        },
        {
            "id": "2013126476711583746",
            "speakerId": 1,
            "speakerName": null,
            "content": "三第三步，区分伪痛点和真痛点，判断可优化性。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 126
        },
        {
            "id": "2013126476745138177",
            "speakerId": 1,
            "speakerName": null,
            "content": "不是所有痛点都值得做，产品差异化需要筛选出可通过产品设计功能优化解决的真痛点，排除伪痛点、真痛点。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 127
        },
        {
            "id": "2013126476778692609",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如无分类隔层可加可拆卸隔板折叠有折痕可换加厚覆膜材质承重差可升级支架用料。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 128
        },
        {
            "id": "2013126476812247041",
            "speakerId": 1,
            "speakerName": null,
            "content": "这类痛点改造成本低，效果直观。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 129
        },
        {
            "id": "2013126476841607169",
            "speakerId": 1,
            "speakerName": null,
            "content": "伪痛点，比如价格太贵属于定价问题，非产品功能问题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 130
        },
        {
            "id": "2013126476875161602",
            "speakerId": 1,
            "speakerName": null,
            "content": "物流太慢属于供应链问题，和产品本身无关。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 131
        },
        {
            "id": "2013126476908716034",
            "speakerId": 1,
            "speakerName": null,
            "content": "这类痛点无需纳入产品差异化设计。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 132
        },
        {
            "id": "2013126476942270465",
            "speakerId": 1,
            "speakerName": null,
            "content": "四第四步，对标自家产品匹配差异化解决方案。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 133
        },
        {
            "id": "2013126476975824898",
            "speakerId": 1,
            "speakerName": null,
            "content": "针对筛选出的高频真痛点，逐一对应自家产品的现有配置，制定痛点加解决方案的对应表举收纳盒的例子。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 134
        },
        {
            "id": "2013126477009379329",
            "speakerId": 1,
            "speakerName": null,
            "content": "五第五步，验证方案可行性，形成落地清单。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 135
        },
        {
            "id": "2013126477038739457",
            "speakerId": 1,
            "speakerName": null,
            "content": "最后一步要评估成本和市场接受度，先和供应商确认差异化方案的改造成本是否在可控范围内。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 136
        },
        {
            "id": "2013126477072293890",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如加隔板成本增加0.5美元，售价可提高3美元，利润率仍有保障。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 137
        },
        {
            "id": "2013126477105848321",
            "speakerId": 1,
            "speakerName": null,
            "content": "在做小范围验证，在listing的A加页面或主图中突出差异化卖点，投放小预算精准广告，观察点击率、转化率是否高于类目均值，若数据达标就确定为核心差异化策略落地。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 138
        },
        {
            "id": "2013126477135208449",
            "speakerId": 0,
            "speakerName": null,
            "content": "你刚才完整的介绍了从挖掘痛点，筛选匹配方案到验证可行性的全流程，这非常系统。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 139
        },
        {
            "id": "2013126477168762882",
            "speakerId": 0,
            "speakerName": null,
            "content": "在完成产品差异化设计和上架后，广告活动管理是推动销量的核心。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 140
        },
        {
            "id": "2013126477202317313",
            "speakerId": 0,
            "speakerName": null,
            "content": "你通常如何更换和执行一个新品的广告活动？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 141
        },
        {
            "id": "2013126477231677441",
            "speakerId": 0,
            "speakerName": null,
            "content": "例如你会如何设置广告结构，预算分配，以及如何根据数据表现进行优化调整。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 142
        },
        {
            "id": "2013126477265231874",
            "speakerId": 1,
            "speakerName": null,
            "content": "新品广告活动的核心思路是先精准测词，再逐步放量，最后降本增效，避免一上来就铺大预算。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 143
        },
        {
            "id": "2013126477298786306",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体从广告结构搭建、预算分配、数据优化三个维度落地，一、广告结构搭建自动加手动组合分层测试。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 144
        },
        {
            "id": "2013126477332340737",
            "speakerId": 1,
            "speakerName": null,
            "content": "我会搭建一个自动广告组加三个手动广告组的基础框架，各司其职，互不干扰。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 145
        },
        {
            "id": "2013126477361700866",
            "speakerId": 1,
            "speakerName": null,
            "content": "一、自动广告组测磁工具目的，抓取亚马逊系统推荐的买家真实搜索的关键词，为手动广告提供词库匹配方式，默认宽泛匹配，开启所有匹配类型投放设置竞价设为类目平均cpc的0.8倍，每日预算控制在20到30美元，持续投放7到10天，不轻易关停。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 146
        },
        {
            "id": "2013126477391060993",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、手动广告组核心放量，基于自动广告的搜索词报表，筛选出有点击、有转化的词，分三个小组精细化投放精准词。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 147
        },
        {
            "id": "2013126477424615426",
            "speakerId": 1,
            "speakerName": null,
            "content": "广告组收入搜索量500到2000，转化率大于等于5%的长尾词，如mini storage box or socks，精准匹配进价为类目平均cpc的1.0到1.2倍，主攻转化短语词，广告组收录搜索量2000到5000的中等词，如foldable storage box with divider短语匹配进价为类目平均cpc的0.9倍，兼顾流量可转化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 148
        },
        {
            "id": "2013126477453975554",
            "speakerId": 1,
            "speakerName": null,
            "content": "否定词，广告组专门存放无词，如chip storage box、keep storage box, 分为精准否定，完全排除不相关词和短语否定，排除部分相关词，避免浪费。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 149
        },
        {
            "id": "2013126477487529985",
            "speakerId": 1,
            "speakerName": null,
            "content": "预算2、预算分配先集中后分散，动态调整新品期预算有限，遵循70%投核心转化、20%投潜力拓展、10%投测试探索的原则。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 150
        },
        {
            "id": "2013126477516890113",
            "speakerId": 1,
            "speakerName": null,
            "content": "一、初期1到2周总预算控制在100到10050美元，每天70%分给精准词广告组，20%分给自动广告组，10%分给短语词广告组，优先保证高转化词的曝光，同时用自动广告挖词。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 151
        },
        {
            "id": "2013126477550444546",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、中期3到4周，根据数据调整，把有转化的短语词升级到精准词组，预算向表现好的小组倾斜，比如某精准词转化率达8%，可将预算占比提高到80%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 152
        },
        {
            "id": "2013126477583998978",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、后期五周加自然流量起来后，逐步降低广告预算占比，把总预算压缩到销售额的10%到15%，重点维护核心词排名，不再盲目扩量。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 153
        },
        {
            "id": "2013126477613359105",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、数据优化，每日盯紧，每周复盘，优胜劣汰，优化核心看点击率ct t 2转化率cv 2a co三个指标按节奏调整。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 154
        },
        {
            "id": "2013126477646913538",
            "speakerId": 1,
            "speakerName": null,
            "content": "一、每日优化，盯紧实时数据，剔除ct R小于1%且无转化的词，避免无效点击。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 155
        },
        {
            "id": "2013126477680467970",
            "speakerId": 1,
            "speakerName": null,
            "content": "对cvr大于等于5%但排名靠后的精准词，小幅提价5%到10%，冲击更好的广告位。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 156
        },
        {
            "id": "2013126477714022401",
            "speakerId": 1,
            "speakerName": null,
            "content": "对a co大于目标值30%的词，先降价观察，若仍无改善则移入否定词库。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 157
        },
        {
            "id": "2013126477743382530",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、每周复盘，批量迭代，导出自动广告的搜索词报表，筛选出有转化的词，加入手动精准词组，分析广告位表现对比首页顶部商品页面其余位置的转化数据，若首页底部a co过高就降低进价转移到商品页面，转化稳定且成本低。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 158
        },
        {
            "id": "2013126477776936962",
            "speakerId": 1,
            "speakerName": null,
            "content": "调整预算分配，把表现差的小组预算转移到a co低转化高的小组，做到好钢用在刀刃上。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 159
        },
        {
            "id": "2013126477806297090",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、特殊情况处理若广告有点击无转化，优先优化listing主图。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 160
        },
        {
            "id": "2013126477839851522",
            "speakerId": 1,
            "speakerName": null,
            "content": "5、点描述价格，而非盲目调整广告。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 161
        },
        {
            "id": "2013126477869211649",
            "speakerId": 1,
            "speakerName": null,
            "content": "若广告无点击无曝光，适当提高竞价或检查关键词与产品的相关性，避免词不匹配。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 162
        },
        {
            "id": "2013126477902766082",
            "speakerId": 1,
            "speakerName": null,
            "content": "整个过程中，广告不是孤立的，必须和listing优化评价积累配合，才能实现广告带动自然流量，自然流量降低广告依赖的良性循环。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 163
        },
        {
            "id": "2013126477936320514",
            "speakerId": 1,
            "speakerName": null,
            "content": "需要我为你整理一份新品广告优化的周度检查表吗？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 164
        },
        {
            "id": "2013126477969874946",
            "speakerId": 1,
            "speakerName": null,
            "content": "可以直接对照执行，避免遗漏关键步骤。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 165
        },
        {
            "id": "2013126478003429378",
            "speakerId": 0,
            "speakerName": null,
            "content": "嗯，先不需要你刚才总结了广告优化的特殊情况处理，这非常实用。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 166
        },
        {
            "id": "2013126478032789505",
            "speakerId": 0,
            "speakerName": null,
            "content": "现在我们来谈谈亚马逊运营中另一个至关重要的环节，合规与风险控制。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 167
        },
        {
            "id": "2013126478062149633",
            "speakerId": 0,
            "speakerName": null,
            "content": "在日常运营中，你是如何系统性的监控和应对产品合规问题？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 168
        },
        {
            "id": "2013126478095704066",
            "speakerId": 0,
            "speakerName": null,
            "content": "如认证安全标准非系统合规，如图文规范以及平台政策变化带来风险带来的风险的。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 169
        },
        {
            "id": "2013126478129258497",
            "speakerId": 1,
            "speakerName": null,
            "content": "在亚马逊运营的合规与风险控制上，我的核心策略是搭建事前预防加事中监控加事后整改的闭环体系，从认证、listing、政策三个核心维度系统性规避风险。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 170
        },
        {
            "id": "2013126478158618626",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体操作如下，一、事前预防从产品选品和上架前筑牢合规基础一、产品认证与安全标准前置核查选品阶段就明确目标站点的合规要求，比如美国站的fda认证、食品接触类cpa认证、儿童产品ul l认证、电器类欧洲站的ce认证。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 171
        },
        {
            "id": "2013126478192173058",
            "speakerId": 1,
            "speakerName": null,
            "content": "Reach法规rose指令要求供应商必须提供第三方权威检测机构出具的认证报告，并核验报告真伪。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 172
        },
        {
            "id": "2013126478221533186",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如在ul官网查询认证编号，杜绝假认证套证。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 173
        },
        {
            "id": "2013126478255087618",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时针对高风险品类如儿童玩具、电器额外做一轮抽检，确保产品实际参数和认证标准一致。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 174
        },
        {
            "id": "2013126478284447746",
            "speakerId": 1,
            "speakerName": null,
            "content": "上架前建立产品合规档案，存档、认证报告、检测数据、供应商资质，做到有据可查。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 175
        },
        {
            "id": "2013126478318002177",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、listing合规预审机制，制定listing合规自查清单，上架前逐条核对图文规范主图必须纯白，背景2亿55255255，无水印、无促销，文字附图不能出现对比图。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 176
        },
        {
            "id": "2013126478351556609",
            "speakerId": 1,
            "speakerName": null,
            "content": "夸张话术，如最好顶级A加页面不能引用未授权的品牌专利内容。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 177
        },
        {
            "id": "2013126478380916737",
            "speakerId": 1,
            "speakerName": null,
            "content": "文案合规，禁用绝对化词汇best、top、highest.",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 178
        },
        {
            "id": "2013126478410276866",
            "speakerId": 1,
            "speakerName": null,
            "content": "医疗功效词如缓解腰痛、抗菌产品参数必须和检测报告一致，不夸大，如承重100斤不能标150斤。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 179
        },
        {
            "id": "2013126478439636993",
            "speakerId": 1,
            "speakerName": null,
            "content": "关键词不堆砌、不侵权，避免使用竞品品牌词由运营和合规专员双人交叉审核，签字确认后再上架。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 180
        },
        {
            "id": "2013126478473191425",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、事中监控日常运营，实时排查，及时止损。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 181
        },
        {
            "id": "2013126478502551554",
            "speakerId": 1,
            "speakerName": null,
            "content": "一每日合规巡检，用工具如卖家精灵子鸟监控listing状态，重点排查是否被平台标记违规信息缺失。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 182
        },
        {
            "id": "2013126478536105986",
            "speakerId": 1,
            "speakerName": null,
            "content": "每日查看店铺后台的绩效通知，政策更新，确保第一时间收到违规预警。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 183
        },
        {
            "id": "2013126478565466113",
            "speakerId": 1,
            "speakerName": null,
            "content": "定期抽检在售listing核对文案图片是否因员工调整或平台政策变化出现违规。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 184
        },
        {
            "id": "2013126478599020546",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如平台新增对环保、可降解等词汇的限制需及时清理。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 185
        },
        {
            "id": "2013126478632574978",
            "speakerId": 1,
            "speakerName": null,
            "content": "监控竞品合规动态，若竞品因认证问题被下载，立刻自查同款产品的认证是否私源，避免踩同款坑。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 186
        },
        {
            "id": "2013126478666129409",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、客户反馈舆情监控，每日查看差评poa和买家消息，重点关注涉及安全隐患的反馈。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 187
        },
        {
            "id": "2013126478699683841",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如买家说电器漏电，儿童玩具零件易脱落，一旦发现这类问题，24小时内启动应急方案，先下架产品，排查原因，若为产品缺陷则召回库存，各为使用不当则补充使用指南，避免升级为平台。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 188
        },
        {
            "id": "2013126478729043970",
            "speakerId": 1,
            "speakerName": null,
            "content": "合规处罚。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 189
        },
        {
            "id": "2013126478758404098",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、事后整改，违规处理与长效优化意违规申诉标准化流程。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 190
        },
        {
            "id": "2013126478791958530",
            "speakerId": 1,
            "speakerName": null,
            "content": "若收到违规通知，如listing违规、认证缺失，按原因分析、整改方案、证据提交三步申诉，先拆解违规条款，明确问题核心，比如是图片有水印还是参数夸大。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 191
        },
        {
            "id": "2013126478821318658",
            "speakerId": 1,
            "speakerName": null,
            "content": "制定具体整改动作，如更换合规主图，修正参数，并留存整改前后的对比截图。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 192
        },
        {
            "id": "2013126478850678785",
            "speakerId": 1,
            "speakerName": null,
            "content": "撰写申诉邮件，逻辑清晰，态度诚恳。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 193
        },
        {
            "id": "2013126478884233217",
            "speakerId": 1,
            "speakerName": null,
            "content": "附上合规证明材料，如认证报告、整改截图提交后每日跟进审核进度。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 194
        },
        {
            "id": "2013126478913593345",
            "speakerId": 1,
            "speakerName": null,
            "content": "申诉成功后，将案例纳入合规风险案例库，全员学习。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 195
        },
        {
            "id": "2013126478947147778",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、政策变化的长效应对。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 196
        },
        {
            "id": "2013126478976507905",
            "speakerId": 1,
            "speakerName": null,
            "content": "订阅亚马逊官方卖家论坛行业合规公众号，设置政策更新提醒每次平台政策调整，如新规限制某类产品材质新增认证，要求第一时间组织团队培训，梳理受影响的sku，分批完成合规整改。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 197
        },
        {
            "id": "2013126479005868034",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时调整选品策略，避开新增的高风险品类。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 198
        },
        {
            "id": "2013126479039422466",
            "speakerId": 1,
            "speakerName": null,
            "content": "总结来说，合规不是事后补救，而是全程嵌入运营的每个环节，通过前置预防减少风险，事中监控及时止损，事后整改避免再犯，才能保障店铺长期稳定运营。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 199
        },
        {
            "id": "2013126479068782593",
            "speakerId": 0,
            "speakerName": null,
            "content": "那如果现在让你接手一个表面平平的老品，你的第一步动作会是什么呢？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 200
        },
        {
            "id": "2013126479102337025",
            "speakerId": 1,
            "speakerName": null,
            "content": "新手表面平平的老品，我的第一步动作是做全维度数据诊断。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 201
        },
        {
            "id": "2013126479131697153",
            "speakerId": 1,
            "speakerName": null,
            "content": "核心是找到销量停滞的核心症结，是流量不够转化不行，还是品控拖后腿，避免盲目优化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 202
        },
        {
            "id": "2013126479161057282",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体会拆解四个核心数据板块，用一天时间完成诊断。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 203
        },
        {
            "id": "2013126479194611713",
            "speakerId": 1,
            "speakerName": null,
            "content": "一流量维度，导出近30天的流量来源报表，看自然流量和广告流量的占比，以及核心关键词的排名变化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 204
        },
        {
            "id": "2013126479228166145",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果自然流量占比低于40%，且核心词排名调出类目前200，说明listing权重下滑是流量端的问题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 205
        },
        {
            "id": "2013126479257526273",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果广告流量占比高，但a co超标就是广告投放效率低。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 206
        },
        {
            "id": "2013126479291080705",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、转化维度分析点击率ct 2、转化率C V 2和竞品的差距，若ct t 2低于类目均值，优先排查主图和标题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 207
        },
        {
            "id": "2013126479320440834",
            "speakerId": 1,
            "speakerName": null,
            "content": "若c p 2低，重点看价格。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 208
        },
        {
            "id": "2013126479353995265",
            "speakerId": 1,
            "speakerName": null,
            "content": "五点描述评价质量，比如差评是否集中在产品痛点。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 209
        },
        {
            "id": "2013126479383355393",
            "speakerId": 1,
            "speakerName": null,
            "content": "三品控维度，统计近30天的退货率、差评率和差评关键词。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 210
        },
        {
            "id": "2013126479416909826",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果差评率超过3%，写高频吐槽材质差、尺寸不符等硬伤，说明产品本身有缺陷，优化listing之前必须先解决品控问题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 211
        },
        {
            "id": "2013126479446269954",
            "speakerId": 1,
            "speakerName": null,
            "content": "4、库存维度，查看fba库存的可售天数、仓储费占比，若库存积压超过60天，会先把新库存纳入优先级。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 212
        },
        {
            "id": "2013126479479824386",
            "speakerId": 1,
            "speakerName": null,
            "content": "若频繁断货，说明之前的补货计划不合理，需要先调整库存模型，诊断完成后会列出优先级整改清单，比如先解决差评集中的品控问题，再优化低转化的listing，最后调整广告和库存策略，避免无力放矢。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 213
        },
        {
            "id": "2013126479513378818",
            "speakerId": 1,
            "speakerName": null,
            "content": "需要我为你整理一份老品数据诊断的自查清单吗？",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 214
        },
        {
            "id": "2013126479546933249",
            "speakerId": 1,
            "speakerName": null,
            "content": "可以直接对照着排查问题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 215
        },
        {
            "id": "2013126479580487682",
            "speakerId": 0,
            "speakerName": null,
            "content": "嗯，先不需要了，谢谢。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 216
        },
        {
            "id": "2013126479609847809",
            "speakerId": 0,
            "speakerName": null,
            "content": "今天的面试就先到这儿，拜拜。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 217
        },
        {
            "id": "2013126479643402242",
            "speakerId": 1,
            "speakerName": null,
            "content": "非常感谢您今天的耐心提问和深入交流。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 218
        },
        {
            "id": "2013126479676956674",
            "speakerId": 1,
            "speakerName": null,
            "content": "这次面试让我对亚马逊运营的实操重点有了更清晰的认知。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 219
        },
        {
            "id": "2013126479706316802",
            "speakerId": 1,
            "speakerName": null,
            "content": "祝您后续工作顺利，也期待能有进一步沟通的机会，拜拜。",
            "modifiedContent": null,
            "nodeId": "2013106421600870402",
            "talkIndex": 220
        }
    ]
},
{
    nodeId: "-1000000026",
    "rows": [
        {
            "id": "2013115429116174337",
            "speakerId": 0,
            "speakerName": null,
            "content": "聊聊你实习期间主动学习亚马逊运营最快的一个技能。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 1
        },
        {
            "id": "2013115429233614849",
            "speakerId": 1,
            "speakerName": null,
            "content": "我实习期间主动掌握最快的技能是亚马逊listing关键词精准白瓷与搜索排名优化，从零基础到独立完成三款新品listing搭建，并实现七天内自然排名进入类目前200只用了十天时间。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 2
        },
        {
            "id": "2013115429267169282",
            "speakerId": 1,
            "speakerName": null,
            "content": "最开始我发现带教师傅优化的listing核心关键词搜索排名远高于我们实习生随便堆砌的版本，就主动去拆解背后的逻辑。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 3
        },
        {
            "id": "2013115429300723713",
            "speakerId": 1,
            "speakerName": null,
            "content": "我先花两天啃完了亚马逊官方的搜索术语优化指南，理清了标题五点描述产品描述search terms的权重规则。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 4
        },
        {
            "id": "2013115429334278146",
            "speakerId": 1,
            "speakerName": null,
            "content": "接着用卖家精灵子鸟、数据魔方这两个工具，通过核心词拓展加竞品流量词8取加长尾词挖掘的组合方法，给一款户外水杯产品筛选出300加相关关键词，再按搜索量、竞争度、转化率三个维度分级，把高搜索、高转化的核心词，比如insulated water bottle 24 ounces放在标题前60字符。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 5
        },
        {
            "id": "2013115429363638273",
            "speakerId": 1,
            "speakerName": null,
            "content": "把中等竞争的长尾词，比如leak proof water bottle for hiking埋进五点描述和产品描述的开头。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 6
        },
        {
            "id": "2013115429392998402",
            "speakerId": 1,
            "speakerName": null,
            "content": "把低竞争的长尾词，比如dishwasher says insulated bottle，整理成third terms的精准短语。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 7
        },
        {
            "id": "2013115429426552833",
            "speakerId": 1,
            "speakerName": null,
            "content": "为了验证效果，我特意做了一个对照组。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 8
        },
        {
            "id": "2013115429460107266",
            "speakerId": 1,
            "speakerName": null,
            "content": "同一批产品一个用我优化的listing，一个用原来的基础版。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 9
        },
        {
            "id": "2013115429489467394",
            "speakerId": 1,
            "speakerName": null,
            "content": "结果七天后我优化的listing，自然搜索流量比基础版高了三倍，还出了五单自然订单。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 10
        },
        {
            "id": "2013115429527216129",
            "speakerId": 1,
            "speakerName": null,
            "content": "后来我把这套方法整理成了一份listing关键词埋词sop分享给了同组的其他实习生，帮大家都缩短了listing优化的上手时间。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 11
        },
        {
            "id": "2013115429560770561",
            "speakerId": 0,
            "speakerName": null,
            "content": "如果遇到从没接触过的运营难题时，你第一反应是什么？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 12
        },
        {
            "id": "2013115429590130689",
            "speakerId": 1,
            "speakerName": null,
            "content": "我的第一反应是先拆解问题本质，再用数据定位加工具辅助加对标参考的思路快速破局，不会急于上手尝试。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 13
        },
        {
            "id": "2013115429623685121",
            "speakerId": 1,
            "speakerName": null,
            "content": "首先我会先明确这个难题的核心影响，比如是listing转化率暴跌，广告a os突然飙升，还是账号遭遇违规警告。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 14
        },
        {
            "id": "2013115429657239554",
            "speakerId": 1,
            "speakerName": null,
            "content": "先锁定问题对应的核心指标，避免盲目排查。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 15
        },
        {
            "id": "2013115429690793986",
            "speakerId": 1,
            "speakerName": null,
            "content": "接着我会调取后台数据做对比分析。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 16
        },
        {
            "id": "2013115429720154113",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如转化率低了，就看流量来源变化、竞品价格波动、差评新增情况。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 17
        },
        {
            "id": "2013115429749514242",
            "speakerId": 1,
            "speakerName": null,
            "content": "广告a source高了，就拆分广告组的关键词，点击转化数据定位，是关键词不精准还是进价过高。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 18
        },
        {
            "id": "2013115429783068674",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果自己的数据分析找不出原因，我会立刻用卖家精灵k用十这类工具啊谈竞品的运营策略，看对方是否调整了价格优惠券或者listing内容，同时也会去亚马逊卖家论坛行业社群搜同类问题的解决方案，参考有经验的运营的处理思路。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 19
        },
        {
            "id": "2013115429820817410",
            "speakerId": 1,
            "speakerName": null,
            "content": "举个实习时的例子，当时一款户外帐篷突然被判定产品描述与实际不符，我从未遇到过这种违规。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 20
        },
        {
            "id": "2013115429850177537",
            "speakerId": 1,
            "speakerName": null,
            "content": "我先拆解问题，是图片展示、参数标注还是关键词使用踩了红线，然后对比违规通知里的具体条款，逐条核对listing内容，发现是帐篷承重参数标注和产品手册不一致。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 21
        },
        {
            "id": "2013115429883731969",
            "speakerId": 1,
            "speakerName": null,
            "content": "接着去论坛查同类违规的申诉模板，再联系供应商拿到官方承重检测报告，最后按问题说明加整改方案加证明材料的结构提交申诉，三天就解决了问题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 22
        },
        {
            "id": "2013115429913092098",
            "speakerId": 1,
            "speakerName": null,
            "content": "整个过程中我不会死磕，而是优先用数据加工具加同行经验的组合权，快速找到解决方向。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 23
        },
        {
            "id": "2013115429946646530",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时会把处理过程和结果整理成案例，方便后续遇到类似问题直接参考。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 24
        },
        {
            "id": "2013115429980200962",
            "speakerId": 1,
            "speakerName": null,
            "content": "你是否想了解我处理某一类具体亚马逊运。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 25
        },
        {
            "id": "2013115430009561089",
            "speakerId": 0,
            "speakerName": null,
            "content": "营难题的完整思路？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 26
        },
        {
            "id": "2013115430043115522",
            "speakerId": 0,
            "speakerName": null,
            "content": "你刚才提到了一个具体的操作流程。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 27
        },
        {
            "id": "2013115430072475649",
            "speakerId": 0,
            "speakerName": null,
            "content": "我想了解在你完成这次关键词优化并应用于产品list前后，有没有去跟踪这些关键词带来的实际效果，比如流量、点击率或订单的变化，你是如何根据这些数据进行后续调整的？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 28
        },
        {
            "id": "2013115430106030082",
            "speakerId": 1,
            "speakerName": null,
            "content": "当然我不仅跟踪了数据，还基于数据做了两轮针对性调整，确保关键词优化的效果最大化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 29
        },
        {
            "id": "2013115430139584513",
            "speakerId": 1,
            "speakerName": null,
            "content": "第一步是搭建数据跟踪看板，我用亚马逊后台的业务报告和关键词排名工具，每天记录三类核心数据。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 30
        },
        {
            "id": "2013115430168944642",
            "speakerId": 1,
            "speakerName": null,
            "content": "一是目标关键词的自然排名，比如核心词insulated water bottle 24 ounces的排名变化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 31
        },
        {
            "id": "2013115430202499074",
            "speakerId": 1,
            "speakerName": null,
            "content": "二是流量数据拆分，自然搜索流量、广告流量的占比以及点击率c p 2。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 32
        },
        {
            "id": "2013115430231859201",
            "speakerId": 1,
            "speakerName": null,
            "content": "三是转化数据，统计关键词对应的订单量和转化率。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 33
        },
        {
            "id": "2013115430265413634",
            "speakerId": 1,
            "speakerName": null,
            "content": "C p 2我还设置了七天为一个观察周期，避免单日数据波动带来的误判。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 34
        },
        {
            "id": "2013115430294773761",
            "speakerId": 1,
            "speakerName": null,
            "content": "第一轮调整是在优化后的第七天，数据显示，核心词insulated water bottle 24 ounces的自然排名从之前的100家冲到了第18名，对应的自然流量涨了三倍，但转化率只有2.1%，低于类目平均的3.5%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 35
        },
        {
            "id": "2013115430328328194",
            "speakerId": 1,
            "speakerName": null,
            "content": "我分析后发现，listing的五点描述里虽然埋了关键词，但对产品的核心卖点，比如24小时保冷防漏杯盖强调不够，用户点击进来后没有购买欲望。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 36
        },
        {
            "id": "2013115430361882626",
            "speakerId": 1,
            "speakerName": null,
            "content": "于是我调整了五点描述的结构，把核心卖点和关键词结合，比如把24 ounces insulated water bottle with leaproof lead放在第一条，同时补充了保冷测试的真实场景，filled with ice water at 8:00a.m., still cold at 8:00p.m.next day.",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 37
        },
        {
            "id": "2013115430391242753",
            "speakerId": 1,
            "speakerName": null,
            "content": "优化后第十天转化率就涨到了3.8%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 38
        },
        {
            "id": "2013115430424797185",
            "speakerId": 1,
            "speakerName": null,
            "content": "第二轮调整在第14天，我发现长尾词leak proof water bottle for hiking的转化率高达5.2%，但排名一直在30名左右，流量占比只有8%，这说明这个长尾词的精准度高，转化潜力大，只是曝光不足。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 39
        },
        {
            "id": "2013115430458351617",
            "speakerId": 1,
            "speakerName": null,
            "content": "我立刻做了两个动作，一是在search turns里把这个长尾词放在更靠前的位置。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 40
        },
        {
            "id": "2013115430491906049",
            "speakerId": 1,
            "speakerName": null,
            "content": "二是开了一个小预算的精准广告，定向这个关键词出价设为类目平均的1.2倍提升曝光调整后一周，这个长尾词的自然排名冲到了第12名，流量占比涨到22%，还带动了整体订单量再涨20%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 41
        },
        {
            "id": "2013115430521266178",
            "speakerId": 1,
            "speakerName": null,
            "content": "整个过程我都把数据变化和调整动作一一对应，整理成了关键词优化、数据跟踪、迭代调整的闭环文档。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 42
        },
        {
            "id": "2013115430554820610",
            "speakerId": 1,
            "speakerName": null,
            "content": "后来公司上新的两款产品都复用了这套方法，新品破零时间缩短了一半。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 43
        },
        {
            "id": "2013115430584180738",
            "speakerId": 0,
            "speakerName": null,
            "content": "刚刚那个帐篷的问题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 44
        },
        {
            "id": "2013115430613540865",
            "speakerId": 0,
            "speakerName": null,
            "content": "处理的很好。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 45
        },
        {
            "id": "2013115430647095298",
            "speakerId": 0,
            "speakerName": null,
            "content": "在整个过程中你提到了联系供应商获取检测报告。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 46
        },
        {
            "id": "2013115430680649729",
            "speakerId": 0,
            "speakerName": null,
            "content": "我想知道当你发现参数不一致时，除了联系供应商，有没有思考过如何从源头上避免这类问题再次发生？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 47
        },
        {
            "id": "2013115430714204162",
            "speakerId": 0,
            "speakerName": null,
            "content": "比如在后续的新品上架流程中，你是否有建立或者建议过什么检查机制或规范？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 48
        },
        {
            "id": "2013115430743564289",
            "speakerId": 1,
            "speakerName": null,
            "content": "有的面试官当时解决完申诉后，我第一时间就复盘了。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 49
        },
        {
            "id": "2013115430772924417",
            "speakerId": 1,
            "speakerName": null,
            "content": "问题根源，新品上架前缺乏listing参数与产品原文件的双向校验环节。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 50
        },
        {
            "id": "2013115430806478849",
            "speakerId": 1,
            "speakerName": null,
            "content": "所以后续我主动牵头和团队一起制定了一套新品listing上架三审机制，从源头上规避这类违规问题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 51
        },
        {
            "id": "2013115430840033281",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体的流程是这样的，一第一审供应商资料校验新品对接时，要求供应商必须提供官方产品手册加第三方检测报告。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 52
        },
        {
            "id": "2013115430869393409",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如帐篷的承重防水等级，水杯的保温时长，我会把这些核心参数整理成产品核心参数清单，作为listing撰写的唯一依据，严禁凭经验或口头描述填写参数。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 53
        },
        {
            "id": "2013115430902947841",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、第二是listing初稿交叉核对。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 54
        },
        {
            "id": "2013115430936502274",
            "speakerId": 1,
            "speakerName": null,
            "content": "我写完listing初稿后，会和负责供应链的同事做交叉校验，他对照产品实物和检测报告，我对照listing的标题五点详情页，逐字逐句核对参数一致性。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 55
        },
        {
            "id": "2013115430965862401",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如帐篷承重标注可承受300斤，必须和检测报告里的最大承重150千克完全对应，同时标注清楚单位换算，避免起义。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 56
        },
        {
            "id": "2013115430999416834",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、第三是上架前合规自查，这一步是最后一道防线，不会用亚马逊的合规政策自查工具。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 57
        },
        {
            "id": "2013115431028776962",
            "speakerId": 1,
            "speakerName": null,
            "content": "再结合手动排查，重点检查三个点，一是参数是否夸大，比如永久保温这类绝对化表述。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 58
        },
        {
            "id": "2013115431062331394",
            "speakerId": 1,
            "speakerName": null,
            "content": "二是图片展示是否和实物一致，比如帐篷图片里的配件是否和售卖清单匹配。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 59
        },
        {
            "id": "2013115431091691522",
            "speakerId": 1,
            "speakerName": null,
            "content": "三是关键词是否涉及违规，比如医用级最环保这类敏感词。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 60
        },
        {
            "id": "2013115431125245954",
            "speakerId": 1,
            "speakerName": null,
            "content": "另外我还建议团队搭建了一个产品参数共享文档库，把所有在售产品的检测报告、参数清单上传到云端，所有运营同事都能随时查阅，避免新人接手时因为信息不对称再次出错。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 61
        },
        {
            "id": "2013115431158800385",
            "speakerId": 1,
            "speakerName": null,
            "content": "这套机制推行后，我们团队后续上新的12款产品，再也没有出现过产品描述与实际不符的违规警告，申诉率直接降到了0。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 62
        },
        {
            "id": "2013115431192354817",
            "speakerId": 0,
            "speakerName": null,
            "content": "那在你负责的sku里最满意的一次销售突破是怎么做到的？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 63
        },
        {
            "id": "2013115431225909250",
            "speakerId": 1,
            "speakerName": null,
            "content": "最满意的是一款折叠露营椅的销售突破，这款产品初期上架一个月，月销仅二十单。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 64
        },
        {
            "id": "2013115431255269377",
            "speakerId": 1,
            "speakerName": null,
            "content": "原来我通过重点优化加精准引流加场景化营销的组合策略，用两个月时间把月销拉升到300加单，成为店铺的小爆款。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 65
        },
        {
            "id": "2013115431288823809",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体操作分三步，一、深挖用户痛点，优化listing转化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 66
        },
        {
            "id": "2013115431322378242",
            "speakerId": 1,
            "speakerName": null,
            "content": "我先扒了竞品的差评，发现买家吐槽最多的是收纳。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 67
        },
        {
            "id": "2013115431355932673",
            "speakerId": 1,
            "speakerName": null,
            "content": "体积大，承重不够，易侧翻，久坐不舒服。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 68
        },
        {
            "id": "2013115431385292801",
            "speakerId": 1,
            "speakerName": null,
            "content": "而我们的产品其实有折叠后仅0点一二立方米，承重180斤，加厚海绵靠背的优势，但原listing没突出。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 69
        },
        {
            "id": "2013115431414652929",
            "speakerId": 1,
            "speakerName": null,
            "content": "于是我重新调整listing标题，前60字符加入compact folcamping chair 180 capacity五点描述，按痛点加卖点的结构写，比如告别收纳烦恼，折叠后巴掌大小轻松塞进背包详情页加了真人实测视频，展示180斤的人坐上去的稳定性，还对比了同类产品的收纳体积，优化后转化率从2.3%涨到了5.82%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 70
        },
        {
            "id": "2013115431448207361",
            "speakerId": 1,
            "speakerName": null,
            "content": "精准广告引流控制aos初期为盲目开广泛广告，而是用黑领石挖了一批长尾精准词，比如compact camping chair for backpacking、heavy duty fallchair for beach, 这类词竞争度低，转化高。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 71
        },
        {
            "id": "2013115431481761794",
            "speakerId": 1,
            "speakerName": null,
            "content": "我开了精准广告组，出价设为类目平均的0.8倍，同时否定了cheap camping chair这类低客单价、低转化的词。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 72
        },
        {
            "id": "2013115431515316226",
            "speakerId": 1,
            "speakerName": null,
            "content": "一周后，广告流量占比从15%涨到40%，ac稳定在18%，远低于类目平均的25%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 73
        },
        {
            "id": "2013115431544676353",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、场景化营销撬动自然流量。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 74
        },
        {
            "id": "2013115431578230786",
            "speakerId": 1,
            "speakerName": null,
            "content": "我发现产品在徒步露营、海滩野餐、房车旅行这三个场景的需求最高，于是在亚马逊帖子posts和A加页面里上传了不同场景的实拍图，比如徒步者背着椅子登山，一家人在海滩用椅子野餐的画面。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 75
        },
        {
            "id": "2013115431607590913",
            "speakerId": 1,
            "speakerName": null,
            "content": "还联系了三个粉丝量5000到10千的户外类微网红寄样品，让他们做真实测评。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 76
        },
        {
            "id": "2013115431636951042",
            "speakerId": 1,
            "speakerName": null,
            "content": "测评视频里突出我们的收纳和承重优势。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 77
        },
        {
            "id": "2013115431670505473",
            "speakerId": 1,
            "speakerName": null,
            "content": "这些内容带动了自然搜索流量上涨，两个月后自然订单占比达到65%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 78
        },
        {
            "id": "2013115431704059906",
            "speakerId": 1,
            "speakerName": null,
            "content": "最后这款产品月销稳定在300加单，利润率从12%提升到22%，还带动了店铺其他露营用品的关联销售。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 79
        },
        {
            "id": "2013115431737614338",
            "speakerId": 1,
            "speakerName": null,
            "content": "你要不要了解这款产品遇到的最大瓶颈和对应的调整策略。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 80
        },
        {
            "id": "2013115431766974466",
            "speakerId": 0,
            "speakerName": null,
            "content": "转化率从2.3%涨到了多少？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 81
        },
        {
            "id": "2013115431796334593",
            "speakerId": 0,
            "speakerName": null,
            "content": "这个提升非常显著，除了性优化，你刚才还提到了精准引流和场景化营销，可以分别详细说明一下这两步你是如何操作的吗？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 82
        },
        {
            "id": "2013115431829889025",
            "speakerId": 0,
            "speakerName": null,
            "content": "例如在精准引流方面，你如何定位和触和触达目标客户？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 83
        },
        {
            "id": "2013115431863443457",
            "speakerId": 0,
            "speakerName": null,
            "content": "在场景化营销方面你又具体做了哪些工作？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 84
        },
        {
            "id": "2013115431896997890",
            "speakerId": 1,
            "speakerName": null,
            "content": "这款折叠露营椅的转化率从2.3%涨到了5.8%，提升了一倍多。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 85
        },
        {
            "id": "2013115431926358017",
            "speakerId": 1,
            "speakerName": null,
            "content": "核心就是靠精准引流和场景化营销放大了listing优化的效果。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 86
        },
        {
            "id": "2013115431959912449",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体操作如下，一、精准引流定位加触达目标客户的核心动作一、第一步，精准定位目标客群，反推关键词和广告策略。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 87
        },
        {
            "id": "2013115431989272577",
            "speakerId": 1,
            "speakerName": null,
            "content": "我先通过亚马逊后台的买家档案和竞品的review分析，锁定了核心目标客群。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 88
        },
        {
            "id": "2013115432027021314",
            "speakerId": 1,
            "speakerName": null,
            "content": "25到40岁的户外爱好者，细分是新徒步背包客、家庭野餐群体、房车短途旅行者。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 89
        },
        {
            "id": "2013115432056381442",
            "speakerId": 1,
            "speakerName": null,
            "content": "这类人群的需求痛点很明确，便携、承重稳、性价比高。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 90
        },
        {
            "id": "2013115432089935874",
            "speakerId": 1,
            "speakerName": null,
            "content": "对cheap、low cost这类低价词不敏感，反而关注contact、heavy duty、comfortable这类功能词。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 91
        },
        {
            "id": "2013115432123490305",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、第二步，关键词分层布局，用精准广告触达挖掘长尾精准词，用heliu m 10的keword tracker工具扒了三个头部竞品的流量词，筛选出搜索量在500到2000之间，竞争度低于0.3的长尾词。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 92
        },
        {
            "id": "2013115432157044737",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如compact camping chair for backpacking、heavy duty folding chair for beach、lightweight camp chair for rv troops.",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 93
        },
        {
            "id": "2013115432190599170",
            "speakerId": 1,
            "speakerName": null,
            "content": "这类词虽然搜索量不算高，但精准度极高，买家搜索时的购买意向很强。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 94
        },
        {
            "id": "2013115432219959298",
            "speakerId": 1,
            "speakerName": null,
            "content": "广告组精细化搭建开了三个独立的精准广告组，分别对应三类客群的关键词，出价设为类目平均的0.8倍，避免和大卖家竞价抬升成本。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 95
        },
        {
            "id": "2013115432257708033",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时严格否定无效词。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 96
        },
        {
            "id": "2013115432287068161",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如kids camping chair，我们的椅子尺寸不适合儿童。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 97
        },
        {
            "id": "2013115432320622594",
            "speakerId": 1,
            "speakerName": null,
            "content": "Cheap folding chair过滤，追求低价的低质客户，减少无效点击。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 98
        },
        {
            "id": "2013115432349982721",
            "speakerId": 1,
            "speakerName": null,
            "content": "数据迭代优化，每天查看广告报表，把ctr低于1%无转化的关键词直接剔除，把转化率高于8%的词单独拎出来，调高出价10%到20%，提升曝光排名。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 99
        },
        {
            "id": "2013115432387731458",
            "speakerId": 1,
            "speakerName": null,
            "content": "一周后广告带来的访客转化率达到了7.2%，远高于自然流量的转化率。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 100
        },
        {
            "id": "2013115432417091585",
            "speakerId": 1,
            "speakerName": null,
            "content": "三第三步，通过关联流量触达潜在客户。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 101
        },
        {
            "id": "2013115432450646018",
            "speakerId": 1,
            "speakerName": null,
            "content": "除了关键词广告，我还设置了商品推广关联广告，把这款露营椅和店铺内的帐篷野餐垫做捆绑推荐。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 102
        },
        {
            "id": "2013115432480006146",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时参与亚马逊的frequently包together加购搭配，设置了买露营椅加野餐店减5美元的组合优惠。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 103
        },
        {
            "id": "2013115432513560578",
            "speakerId": 1,
            "speakerName": null,
            "content": "触达那些已经在看帐篷野餐店的潜在客户，这部分关联流量的转化率也达到了4.52%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 104
        },
        {
            "id": "2013115432547115009",
            "speakerId": 1,
            "speakerName": null,
            "content": "场景化营销，让客户身临其境提升购买欲望。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 105
        },
        {
            "id": "2013115432580669441",
            "speakerId": 1,
            "speakerName": null,
            "content": "一A加页面和主图视频的场景化改造，原主图只有白底产品图，我换成了真人场景实拍图。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 106
        },
        {
            "id": "2013115432614223874",
            "speakerId": 1,
            "speakerName": null,
            "content": "第一张主图是徒步者把折叠后的椅子塞进双肩包的画面，配文字fits in your backpack。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 107
        },
        {
            "id": "2013115432643584001",
            "speakerId": 1,
            "speakerName": null,
            "content": "后面的附图分别展示了海滩野餐、房车露营、山顶休息三个场景。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 108
        },
        {
            "id": "2013115432672944130",
            "speakerId": 1,
            "speakerName": null,
            "content": "每张图都突出一个核心卖点，比如。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 109
        },
        {
            "id": "2013115432706498562",
            "speakerId": 1,
            "speakerName": null,
            "content": "这款折叠露营椅的转化率从2.3%涨到了5%点。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 110
        },
        {
            "id": "2013115432740052993",
            "speakerId": 0,
            "speakerName": null,
            "content": "继续刚才的说就行。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 111
        },
        {
            "id": "2013115432769413122",
            "speakerId": 1,
            "speakerName": null,
            "content": "好的，面试官其实在广告投放的第二周就遇到了ac os突然从18%飙升到32%的问题，远超我们25%的目标阈值。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 112
        },
        {
            "id": "2013115432802967553",
            "speakerId": 1,
            "speakerName": null,
            "content": "我当时是这样排查和调整的，首先我拆分了广告报表的核心数据，发现是heavy duty folding chair for beach。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 113
        },
        {
            "id": "2013115432832327681",
            "speakerId": 1,
            "speakerName": null,
            "content": "这个广告组的ac长的最离谱，从19%涨到了35%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 114
        },
        {
            "id": "2013115432865882113",
            "speakerId": 1,
            "speakerName": null,
            "content": "进一步拆解后看到这个组的曝光量涨了2倍，但点击率ct t 2从2.1%降到了1.2%，转化率ct 2从6.8%跌到了2.3%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 115
        },
        {
            "id": "2013115432899436545",
            "speakerId": 1,
            "speakerName": null,
            "content": "我立刻去查了竞品动态，发现有两个竞品在做夏日海滩用品促销，不仅降价15%，还挂了亚马逊的限时秒杀标识。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 116
        },
        {
            "id": "2013115432932990978",
            "speakerId": 1,
            "speakerName": null,
            "content": "我们的产品价格没优势，而且广告创意里的海滩场景图还是静态的，和竞品的秒杀视频比吸引力差很多。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 117
        },
        {
            "id": "2013115432962351106",
            "speakerId": 1,
            "speakerName": null,
            "content": "针对这个问题我做了三个调整动作，一短期调价加优惠券，对冲竞品优势，申请了10%的限时优惠券，设置成仅针对广告点击的买家，可见既不影响自然流量的利润，又能抵消竞品的价格优势。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 118
        },
        {
            "id": "2013115432995905538",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时把这个广告组的竞价下调15%，避免在价格战里抬升成本。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 119
        },
        {
            "id": "2013115433029459969",
            "speakerId": 1,
            "speakerName": null,
            "content": "优化广告创意，强化场景差异化，把广告图换成雨天海滩使用的实拍图。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 120
        },
        {
            "id": "2013115433058820097",
            "speakerId": 1,
            "speakerName": null,
            "content": "因为我们的椅子面料是防泼水面料，而竞品的面料不防水，这是我们的隐藏卖点。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 121
        },
        {
            "id": "2013115433092374530",
            "speakerId": 1,
            "speakerName": null,
            "content": "图上配文rain proof for beach days，和竞品的普通海滩场景形成区隔。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 122
        },
        {
            "id": "2013115433125928962",
            "speakerId": 1,
            "speakerName": null,
            "content": "调整后cr回升到2.53%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 123
        },
        {
            "id": "2013115433155289090",
            "speakerId": 1,
            "speakerName": null,
            "content": "拆分关键词匹配方式过滤无效流量。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 124
        },
        {
            "id": "2013115433188843522",
            "speakerId": 1,
            "speakerName": null,
            "content": "之前这个组用的是短语匹配，导致很多不精准的流量进来。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 125
        },
        {
            "id": "2013115433218203649",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如beach chair for kids，large beach chair set, 我把核心词heavy duty folding chair for beach改成精准匹配，只触达搜索这个完整短语的买家，同时把beach chair这类宽泛词拆分到新的广泛广告组，单独控制预算，避免影响核心词的转化。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 126
        },
        {
            "id": "2013115433260146690",
            "speakerId": 1,
            "speakerName": null,
            "content": "数据调整后，第三天这个广告组的accos就降到了22%，第七天稳定在19%，既保住了流量，又没牺牲利润。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 127
        },
        {
            "id": "2013115433289506817",
            "speakerId": 1,
            "speakerName": null,
            "content": "更重要的是，通过这次调整，我总结出一个规律，户外用品的广告投放要跟着季节和竞品促销节奏走，不能一成不变。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 128
        },
        {
            "id": "2013115433318866946",
            "speakerId": 1,
            "speakerName": null,
            "content": "后来我把这个规律加到了团队的广告优化sop里，每次竞品有大动作，我们都能提前三天调整策略。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 129
        },
        {
            "id": "2013115433352421377",
            "speakerId": 1,
            "speakerName": null,
            "content": "这次调整后，这款露营椅的广告流量占比稳定在35%，自然流量占比65%，月销300加单的状态持续了四个月，直到进入淡季才慢慢回落。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 130
        },
        {
            "id": "2013115433385975809",
            "speakerId": 0,
            "speakerName": null,
            "content": "请说一下你处理过最棘手的客户售后问题是什么？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 131
        },
        {
            "id": "2013115433415335937",
            "speakerId": 0,
            "speakerName": null,
            "content": "当时第一反应是保护公司利益，还是很是客户体验？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 132
        },
        {
            "id": "2013115433453084673",
            "speakerId": 1,
            "speakerName": null,
            "content": "最棘手的一次是一款露营椅的海外仓退货纠纷，买家收到货后反馈椅子承重不足断裂，要求全额退款加承担双倍运费，还扬言要在平台留差评，发起a to z索赔。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 133
        },
        {
            "id": "2013115433495027713",
            "speakerId": 1,
            "speakerName": null,
            "content": "但我们的产品检测报告明确标注承重180斤，初步判断是买家超承重使用导致的。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 134
        },
        {
            "id": "2013115433528582146",
            "speakerId": 1,
            "speakerName": null,
            "content": "当时我的第一反应是，在合规前提下平衡公司利益和客户体验，不是非此即彼的选择。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 135
        },
        {
            "id": "2013115433562136578",
            "speakerId": 1,
            "speakerName": null,
            "content": "因为牺牲任何一方，要么会让公司承担无理由损失，要么会影响店铺绩效和口碑。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 136
        },
        {
            "id": "2013115433595691009",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体处理步骤是这样的，一、先共情安抚，稳住客户情绪。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 137
        },
        {
            "id": "2013115433625051138",
            "speakerId": 1,
            "speakerName": null,
            "content": "我没有直接反驳买家，而是先道歉。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 138
        },
        {
            "id": "2013115433658605569",
            "speakerId": 1,
            "speakerName": null,
            "content": "很抱歉给你带来了不好的使用体验，我们非常重视这个问题，会帮你妥善解决。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 139
        },
        {
            "id": "2013115433687965697",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时引导买家提供椅子断裂部位的实拍图使用场景的照片，买家后来发来的照片里能明显看到椅子上坐了两个成年人，远超承重标准。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 140
        },
        {
            "id": "2013115433734103041",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、用数据和证据理性沟通，界定责任。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 141
        },
        {
            "id": "2013115433763463169",
            "speakerId": 1,
            "speakerName": null,
            "content": "我把产品的第三方检测报告翻译成英文发给买家，圈出承重180斤的核心条款，再结合他提供的照片，客观说明此次断裂大概率是超承重使用导致的，不属于产品质量问题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 142
        },
        {
            "id": "2013115433792823297",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时，我也没有完全强硬，而是提出折中方案，可以给他补发一个全新的椅面配件，成本仅10美元，无需他退回旧件，运费由我们承担。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 143
        },
        {
            "id": "2013115433826377730",
            "speakerId": 1,
            "speakerName": null,
            "content": "这个方案既避免了全额退款的损失，也体现了我们的诚意。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 144
        },
        {
            "id": "2013115433859932162",
            "speakerId": 1,
            "speakerName": null,
            "content": "3、跟进售后闭环，避免差评和索赔。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 145
        },
        {
            "id": "2013115433893486593",
            "speakerId": 1,
            "speakerName": null,
            "content": "配件寄出后，我把物流单号发给买家，还附了一份正确使用和保养指南。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 146
        },
        {
            "id": "2013115433927041026",
            "speakerId": 1,
            "speakerName": null,
            "content": "买家收到配件后，自己安装好了椅子，不仅撤销了a to z索赔的申请，还主动发来感谢信说没想到我们会这么负责。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 147
        },
        {
            "id": "2013115433956401153",
            "speakerId": 1,
            "speakerName": null,
            "content": "最后给了一个四星好评扣一星，是因为安装有点麻烦。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 148
        },
        {
            "id": "2013115433989955586",
            "speakerId": 1,
            "speakerName": null,
            "content": "整个过程中，我没有优先考虑只保公司利益而拒绝沟通，也没有为了讨好客户而全额退款。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 149
        },
        {
            "id": "2013115434019315714",
            "speakerId": 1,
            "speakerName": null,
            "content": "平衡的关键是用证据界定责任，再用低成本的解决方案传递诚意。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 150
        },
        {
            "id": "2013115434057064449",
            "speakerId": 1,
            "speakerName": null,
            "content": "后来我把这类售后案例整理成了跨境售后纠纷处理sop，明确了先取证再共情后折中的处理原则，帮团队减少了30%的无理由退款损失。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 151
        },
        {
            "id": "2013115434086424577",
            "speakerId": 1,
            "speakerName": null,
            "content": "你要不要了解我应对亚马逊H Z索赔的具体处理流程？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 152
        },
        {
            "id": "2013115434115784706",
            "speakerId": 0,
            "speakerName": null,
            "content": "Yeah.",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 153
        },
        {
            "id": "2013115434149339138",
            "speakerId": 1,
            "speakerName": null,
            "content": "好的，面试官，我总结的亚马逊a to z索赔完整的流程，核心是48小时内响应加证据链闭环加主动沟通角责。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 154
        },
        {
            "id": "2013115434178699266",
            "speakerId": 1,
            "speakerName": null,
            "content": "具体分为五步，结合之前的录营，以案例拆解一第一步第一时间预警签收，避免超时默认败诉。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 155
        },
        {
            "id": "2013115434212253697",
            "speakerId": 1,
            "speakerName": null,
            "content": "亚马逊要求卖家48小时内对a to z索赔做出回应，超市系统会直接判定买家胜诉，不仅全额退款，还会影响店铺Oddr指标。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 156
        },
        {
            "id": "2013115434245808130",
            "speakerId": 1,
            "speakerName": null,
            "content": "所以我会设置后台索赔提醒，一旦有新索赔生成，立刻同步到工作群，确保一小时内承接处理。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 157
        },
        {
            "id": "2013115434279362562",
            "speakerId": 1,
            "speakerName": null,
            "content": "向露营以那次买家发起索赔后，我30分钟内就先在后台点击respond to a to z claim，提交了正在核实情况，会尽快给出解决方案的初步响应，避免超时风险。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 158
        },
        {
            "id": "2013115434308722689",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、第二步，拆解索赔原因，针对性收集证据链。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 159
        },
        {
            "id": "2013115434338082818",
            "speakerId": 1,
            "speakerName": null,
            "content": "先看买家的索赔理由，常见的有未收到货，产品质量问题与描述不符，在反向收集能证明卖家无责的证据，证据必须真实可核验，缺一不可。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 160
        },
        {
            "id": "2013115434371637250",
            "speakerId": 1,
            "speakerName": null,
            "content": "针对产品质量问题，准备第三方检测报告证明产品符合标注标准。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 161
        },
        {
            "id": "2013115434405191681",
            "speakerId": 1,
            "speakerName": null,
            "content": "买家提供的实物破损图分析是否为使用不当导致。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 162
        },
        {
            "id": "2013115434438746113",
            "speakerId": 1,
            "speakerName": null,
            "content": "Listing详情页截图证明参数如实描述，比如露营乙的180斤承重标注，针对未收到货准备物流妥投证明，比如usps的签收记录、快递柜拍照、订单发货记录带物流单号和发货时间。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 163
        },
        {
            "id": "2013115434468106242",
            "speakerId": 1,
            "speakerName": null,
            "content": "所有证据都要翻译成英文，命名清晰。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 164
        },
        {
            "id": "2013115434501660673",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如camping chair wait test report pdf，方便亚马逊团队审核。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 165
        },
        {
            "id": "2013115434531020801",
            "speakerId": 1,
            "speakerName": null,
            "content": "三第三步，双线沟通，同时对接买家和亚马逊对接买家不纠结谁对谁错，而是用友好的语气引导，提供更多信息，同时给出折中方案。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 166
        },
        {
            "id": "2013115434568769538",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如露营与案例中，我给买家发邮件，我们看到你反馈的问题，从照片看，椅子断裂可能是超承重使用导致，但我们很重视你的体验，愿意免费补发椅面配件，无需退回旧件，既点明责任又给足台阶，避免买家坚持索赔对接亚马逊，在后台提交完整的证据链，并用简洁的语言说明情况。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 167
        },
        {
            "id": "2013115434598129666",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如买家反馈椅子断裂，但检测报告显示产品承重180斤，买家提供的照片中可见，两人同时乘坐远超承重标准。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 168
        },
        {
            "id": "2013115434631684097",
            "speakerId": 1,
            "speakerName": null,
            "content": "我方已提出补发配件的解决方案，望平台公正审核。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 169
        },
        {
            "id": "2013115434665238530",
            "speakerId": 1,
            "speakerName": null,
            "content": "4、第四步，跟踪审核进度，及时调整方案。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 170
        },
        {
            "id": "2013115434698792962",
            "speakerId": 1,
            "speakerName": null,
            "content": "提交证据后，每天查看索赔状态，pending under review resolved.",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 171
        },
        {
            "id": "2013115434728153089",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果亚马逊倾向买家，其损失在可控范围内会适当让步，比如承担一半运费退款，避免升级为平台纠纷，影响店铺绩效。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 172
        },
        {
            "id": "2013115434761707522",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果证据确凿，就坚持立场，等待平台判定。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 173
        },
        {
            "id": "2013115434795261954",
            "speakerId": 1,
            "speakerName": null,
            "content": "那次露营已索赔，因为证据充分，加上买家已经接受补发方案，最终买家主动撤销了索赔。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 174
        },
        {
            "id": "2013115434824622082",
            "speakerId": 1,
            "speakerName": null,
            "content": "五第五步即案复盘，沉淀预防机制。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 175
        },
        {
            "id": "2013115434858176513",
            "speakerId": 1,
            "speakerName": null,
            "content": "索赔解决后会把整个过程记录到售后案例库，包括索赔原因、证据清单、处理方案、结果，同时针对问题优化前端流程。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 176
        },
        {
            "id": "2013115434895925250",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如露营以事件后，我在listing的五点描述里加了禁止两人及以上同时乘坐的警示语，还在产品包装里放了纸质的使用指南，从源头减少同类索赔。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 177
        },
        {
            "id": "2013115434925285378",
            "speakerId": 1,
            "speakerName": null,
            "content": "这套流程下来，我处理了12起a to c索赔中，8起买家主动撤销，三起平台判定卖家无责，仅一起小额退款，店铺的Oddr指标一直稳定在0.8%以下，远低于亚马逊的及时现1%。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 178
        },
        {
            "id": "2013115434963034114",
            "speakerId": 0,
            "speakerName": null,
            "content": "那怎么判断该不该给客。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 179
        },
        {
            "id": "2013115434988199938",
            "speakerId": 1,
            "speakerName": null,
            "content": "户退款？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 180
        },
        {
            "id": "2013115435021754370",
            "speakerId": 1,
            "speakerName": null,
            "content": "判断是否给客户退款，核心是以证据界定责任加结合店铺成本与绩效影响做权衡，不是一刀切。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 181
        },
        {
            "id": "2013115435055308801",
            "speakerId": 1,
            "speakerName": null,
            "content": "我总结了三个核心判断维度，再配合具体场景决策一维度一，先看责任归属，用证据说话，卖家全责。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 182
        },
        {
            "id": "2013115435093057538",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如发错货，产品本身有质量缺陷、物流丢件且无妥投证明，这种情况直接全额退款不纠结，不仅要退货款，还得主动承担退货运费，避免买家发起a to z索赔或留差评影响店铺Oddr指标。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 183
        },
        {
            "id": "2013115435122417665",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如之前有个订单，仓库把小号录营，已发成大号，我直接联系买家道歉，全额退款加承担运费，还额外送了一张5美元优惠券，买家最后给了五星好评，买家责任。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 184
        },
        {
            "id": "2013115435155972097",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如超承重使用，人为损坏，买错型号后反悔，这种情况优先拒绝全额退款，用低成本方案折中。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 185
        },
        {
            "id": "2013115435185332225",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如补发配件送优惠券，而不是直接退款。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 186
        },
        {
            "id": "2013115435218886658",
            "speakerId": 1,
            "speakerName": null,
            "content": "就像之前的露营已断裂案例，证据明确是买家超用导致，所以选择补发一面配件，既控制了成本，又保住了客户口碑，责任模糊。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 187
        },
        {
            "id": "2013115435252441089",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如买家说产品有瑕疵，但无法提供清晰照片，这种情况先引导取证，再给小额补偿。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 188
        },
        {
            "id": "2013115435285995522",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如退10%到20%货款，无需退货，避免纠缠。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 189
        },
        {
            "id": "2013115435319549954",
            "speakerId": 1,
            "speakerName": null,
            "content": "2、维度2，再算成本账，对比退款损失和不退款的风险损失。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 190
        },
        {
            "id": "2013115435348910082",
            "speakerId": 1,
            "speakerName": null,
            "content": "有些情况即使是买家责任也要权衡利弊。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 191
        },
        {
            "id": "2013115435378270209",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如买家是高价值客户，多次复购或者纠纷升级可能导致账号警告，这时候小额退款比硬糖更划算。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 192
        },
        {
            "id": "2013115435411824642",
            "speakerId": 1,
            "speakerName": null,
            "content": "举个例子，有个买家买了帐篷后说支架有点松，但无法提供照片。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 193
        },
        {
            "id": "2013115435445379073",
            "speakerId": 1,
            "speakerName": null,
            "content": "查他的购买记录，发现是店铺的复购，客户累计消费超200美元，最后我退了15%货款，没让退货。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 194
        },
        {
            "id": "2013115435478933506",
            "speakerId": 1,
            "speakerName": null,
            "content": "因为硬卡可能会失去这个客户，还可能换来差评，损失远大于15%的货款。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 195
        },
        {
            "id": "2013115435508293634",
            "speakerId": 1,
            "speakerName": null,
            "content": "三维度3，参考亚马逊规则红线，避免踩坑。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 196
        },
        {
            "id": "2013115435537653761",
            "speakerId": 1,
            "speakerName": null,
            "content": "亚马逊有明确的买家友好政策，比如不收到货，30天内可无理由退货，部分品类除外。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 197
        },
        {
            "id": "2013115435571208193",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果买家符合规则且坚持退款，不要拒绝，而是按规则处理，否则平台嵌入后不仅要退款，还会扣分。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 198
        },
        {
            "id": "2013115435604762626",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如有买家买了野餐垫后说不喜欢颜色要退款，虽然是买家主观原因，但符合无理由退货规则，我就同意退款。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 199
        },
        {
            "id": "2013115435638317057",
            "speakerId": 1,
            "speakerName": null,
            "content": "同时引导他走官方退货流程，确保退货后再退款，避免被骗。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 200
        },
        {
            "id": "2013115435667677186",
            "speakerId": 1,
            "speakerName": null,
            "content": "最后我会把这些判断标准整理成退款决策清单，每次遇到售后纠纷，对照清单勾选就能快速做出决定，既不盲目让利，也不硬扛风险。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 201
        },
        {
            "id": "2013115435701231618",
            "speakerId": 1,
            "speakerName": null,
            "content": "你要不要了解我整理的亚马逊售后退款决策清单模板？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 202
        },
        {
            "id": "2013115435734786050",
            "speakerId": 0,
            "speakerName": null,
            "content": "如果为了客户满意要自己额外加班，你心里会怎么想？",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 203
        },
        {
            "id": "2013115435768340482",
            "speakerId": 1,
            "speakerName": null,
            "content": "不会觉得是额外的负担，反而会把加班处理客户问题看作是维护店铺口碑和长期收益的必要投入。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 204
        },
        {
            "id": "2013115435793506306",
            "speakerId": 1,
            "speakerName": null,
            "content": "亚马逊运营的核心就是流量加转化加复购，而客户满意度直接影响复购率和店铺评分。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 205
        },
        {
            "id": "2013115435831255042",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如之前处理露营已售后时，我加班整理英文检测报告，跟进配件物流，虽然多花了两个晚上，但最终让买家撤销索赔，还留了好评，避免了欧Dr R指标受损，也保住了这个客户后续可能的复购。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 206
        },
        {
            "id": "2013115435864809474",
            "speakerId": 1,
            "speakerName": null,
            "content": "而且对我来说，加班解决的不是别人的问题，而是自己负责的sku的问题。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 207
        },
        {
            "id": "2013115435894169602",
            "speakerId": 1,
            "speakerName": null,
            "content": "只有把每个售后，每个客户的需求都处理到位，才能让自己负责的产品稳定出单。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 208
        },
        {
            "id": "2013115435931918338",
            "speakerId": 1,
            "speakerName": null,
            "content": "另外我会在加班后做两件事，一是复盘这次加班的原因，看能不能优化流程，避免下次重复加班。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 209
        },
        {
            "id": "2013115435961278466",
            "speakerId": 1,
            "speakerName": null,
            "content": "比如那次售后之后，我整理了常见索赔证据包模板，后续遇到类似问题直接套用，节省了一半时间。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 210
        },
        {
            "id": "2013115435994832898",
            "speakerId": 1,
            "speakerName": null,
            "content": "二是合理规划时间，把常规工作在上班时间高效完成，把加班的精力集中在紧急且重要的客户问题上，不会让自己陷入无意义的低效加班。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 211
        },
        {
            "id": "2013115436024193025",
            "speakerId": 1,
            "speakerName": null,
            "content": "总的来说，只要是对店铺，对自己负责的产品有帮助的加班，我是愿意投入的。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 212
        },
        {
            "id": "2013115436053553153",
            "speakerId": 1,
            "speakerName": null,
            "content": "毕竟运营的成果最终都体现在客户的反馈和销售数据里。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 213
        },
        {
            "id": "2013115436087107585",
            "speakerId": 0,
            "speakerName": null,
            "content": "好，感谢你参加本次面试。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 214
        },
        {
            "id": "2013115436120662018",
            "speakerId": 1,
            "speakerName": null,
            "content": "谢谢。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 215
        },
        {
            "id": "2013115436154216450",
            "speakerId": 1,
            "speakerName": null,
            "content": "非常感谢您今天的耐心提问和细致交流。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 216
        },
        {
            "id": "2013115436183576577",
            "speakerId": 1,
            "speakerName": null,
            "content": "这次面试让我对亚马逊运营岗位的实操要求有了更清晰的认知，也很荣幸能分享我的工作经验和思考方法。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 217
        },
        {
            "id": "2013115436217131010",
            "speakerId": 1,
            "speakerName": null,
            "content": "如果有后续的沟通机会，我非常期待能进一步和您探讨团队的运营策略与新品规划。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 218
        },
        {
            "id": "2013115436246491138",
            "speakerId": 1,
            "speakerName": null,
            "content": "再次感谢您的时间，祝您工作顺利。",
            "modifiedContent": null,
            "nodeId": "2013106421600870401",
            "talkIndex": 219
        }
    ],
}
]

// 节点报告列表 mock 数据（按节点ID组织）
const interviewReportList = [
    {
        nodeId: "-1000000026",
        data: {
            id: '-2013115545487138817',
            summary: null,
            suggestion: '求职者在【持续成长与自我驱动】和【目标力】上表现突出，展现了强大的自学能力、结构化思维和以数据驱动达成目标的能力。建议后续面试可重点考察其【客户导向与责任担当】的深度：1. 设置冲突性更强的场景（如客户体验与公司利益的根本性冲突、处理恶意差评），考察其平衡原则性与灵活性的策略及对"责任"边界的理解。2. 追问其方法论（如SOP、案例库）在团队中推广时的阻力及如何应对，考察其影响他人和推动流程落地的能力。3. 探讨其对于"客户导向"在运营策略（如选品、定价）层面的宏观思考，而非仅限于售后处理，判断其是否具备从用户视角驱动业务增长的潜力。',
            candidateRate: 78,
            overallAssessment: '候选人是一名具备出色结构化思维和闭环复盘能力的亚马逊运营新秀。展现出远超实习生的成熟度，不仅精通关键词优化、广告投放、场景营销等核心运营技能，更善于将实践经验提炼为可复用的SOP和预防机制，具备强烈的数据驱动意识和主动推动流程优化的潜力。其思维模式已从单一执行者向\'执行-复盘-优化-分享\'的团队贡献者进阶，是具备快速成长为业务骨干或初级管理者潜质的高潜力人才。',
            highlights: JSON.stringify([
                '卓越的结构化问题解决能力：面对任何运营难题（如关键词优化、广告Acos飙升、违规申诉），均能快速拆解问题本质，采用\'数据定位+工具辅助+对标参考\'的系统性方法，形成从分析、执行到验证的完整闭环。',
                '强大的数据驱动与迭代优化意识：不满足于单次操作，始终强调数据跟踪与效果验证。例如，在关键词优化后，通过搭建数据看板、设置观察周期，并基于流量和转化率数据进行多轮精细化调整，最终将方法沉淀为可复用的闭环文档。',
                '主动的流程优化与知识沉淀习惯：不止于解决问题，更注重从源头预防和团队赋能。在经历产品参数违规后，主动牵头制定\'新品上架三审机制\'；将处理过的售后纠纷、广告优化策略等整理成SOP和决策清单，显著降低了团队错误率和损失。',
                '成熟的客户与利益平衡智慧：在处理棘手售后时，展现出超越年龄的冷静与策略。坚持\'用证据界定责任\'，同时通过低成本折中方案（如补发配件）传递诚意，成功将潜在差评和索赔转化为客户满意，体现了优秀的风险与成本权衡能力。'
            ]),
            potentialRisks: JSON.stringify([
                '经验深度有待市场验证：所有成功案例均基于实习经历，虽成果显著，但尚未经历完整产品生命周期、激烈市场竞争或大规模预算管理的考验，其方法论在更复杂业务场景下的普适性和抗压性需观察。',
                '可能存在过度"流程化"倾向：候选人极度热衷于建立SOP和机制，在快速变化的电商环境中，需警惕其思维是否足够灵活，能否在遵循流程与抓住市场突发机会之间取得平衡。',
                '沟通主动性稍显强势：在面试中多次主动引导话题（如"你要不要了解…"），虽体现了自信和准备充分，但在实际团队协作中，需注意沟通方式，避免给同事或上级留下过于主导或打断的印象。'
            ]),
            factualContext: JSON.stringify([
                '实习期间主动快速掌握了亚马逊Listing关键词优化与搜索排名提升技能，实现了新品7天内自然排名进入类目前200的成果。',
                '独立负责过户外水杯、折叠露营椅、户外帐篷等多款产品的运营，其中将一款月销20单的露营椅通过痛点优化、精准广告和场景化营销，在两个月内提升至月销300+单的店铺小爆款。',
                '熟练使用卖家精灵、Helium 10等第三方工具进行关键词挖掘、竞品分析和广告优化。',
                '具备完整的售后纠纷处理经验，包括应对A-to-Z索赔，并成功通过证据链和沟通策略维护了店铺绩效（ODR指标低于0.8%）。',
                '具备强烈的团队贡献意识，乐于将个人经验总结成SOP文档分享给团队，以提升整体效率。'
            ]),
            keywords: [
                { id: '-2013115545642328065', keyword: 'listing', count: 12, reportId: '-2013115545487138817' },
                { id: '-2013115545759768577', keyword: '关键词', count: 9, reportId: '-2013115545487138817' },
                { id: '-2013115545797517314', keyword: '广告', count: 9, reportId: '-2013115545487138817' },
                { id: '-2013115545826877441', keyword: '数据', count: 7, reportId: '-2013115545487138817' },
                { id: '-2013115545860431874', keyword: '转化率', count: 6, reportId: '-2013115545487138817' },
                { id: '-2013115545889792002', keyword: '流量', count: 6, reportId: '-2013115545487138817' },
                { id: '-2013115545923346433', keyword: '亚马逊', count: 5, reportId: '-2013115545487138817' },
                { id: '-2013115545952706561', keyword: '产品', count: 5, reportId: '-2013115545487138817' },
                { id: '-2013115545986260993', keyword: '优化', count: 5, reportId: '-2013115545487138817' },
                { id: '-2013115546015621121', keyword: '露营椅', count: 5, reportId: '-2013115545487138817' },
                { id: '-2013115546049175554', keyword: '售后', count: 4, reportId: '-2013115545487138817' },
                { id: '-2013115546078535682', keyword: '工具', count: 4, reportId: '-2013115545487138817' },
                { id: '-2013115546112090113', keyword: '竞品', count: 4, reportId: '-2013115545487138817' },
                { id: '-2013115546145644546', keyword: '问题', count: 4, reportId: '-2013115545487138817' },
                { id: '-2013115546179198977', keyword: '调整', count: 4, reportId: '-2013115545487138817' },
                { id: '-2013115546212753410', keyword: '报告', count: 3, reportId: '-2013115545487138817' },
                { id: '-2013115546242113537', keyword: '核心', count: 3, reportId: '-2013115545487138817' },
                { id: '-2013115546275667970', keyword: '流程', count: 3, reportId: '-2013115545487138817' },
                { id: '-2013115546305028098', keyword: '违规', count: 3, reportId: '-2013115545487138817' },
                { id: '-2013115546338582530', keyword: '方案', count: 3, reportId: '-2013115545487138817' },
                { id: '-2013115546372136962', keyword: '客户', count: 3, reportId: '-2013115545487138817' },
                { id: '-2013115546401497089', keyword: '自然', count: 3, reportId: '-2013115545487138817' },
                { id: '-2013115546435051522', keyword: '团队', count: 3, reportId: '-2013115545487138817' },
                { id: '-2013115546468605954', keyword: 'sop', count: 3, reportId: '-2013115545487138817' }
            ]
        }
    },
    {
        nodeId: "-1000000027",
        data: {
            id: '2013126635767980033',
            summary: null,
            suggestion: '求职者在产品生命周期管理、数据分析和亚马逊平台运营方面展现了扎实的实操经验和系统性思维。建议后续面试可深入考察：1. **战略决策与权衡**：提出一个资源（预算、人力）有限且数据指标相互冲突的复杂场景（如高流量低转化 vs. 低流量高转化），考察其如何基于业务目标（利润、份额、品牌）进行优先级排序和最终决策。2. **跨部门/供应链协同**：询问当产品出现品控或合规问题时，如何与产品开发、供应链、法务等部门沟通协作，推动根本性解决，而非仅停留在运营端优化。3. **风险预判与压力测试**：针对其制定的新品推广或老品复兴计划，假设关键外部条件突变（如平台算法调整、核心关键词CPC暴涨、主力供应商断供），考察其应急方案和风险缓释措施的完备性。4. **量化成果深度挖掘**：要求其用具体数字（如通过优化将ACOS从X%降至Y%，带动自然流量占比提升Z%）详细阐述过往最成功的一次产品拯救或新品打造案例，并复盘过程中的关键转折点和最大教训。',
            candidateRate: 80,
            nodeId: '2013106421600870402',
            overallAssessment: '候选人是一位经验丰富、逻辑清晰、数据驱动型的亚马逊运营专家。其展现出强大的系统化思维和落地执行能力，能够将复杂的运营流程拆解为可量化、可追踪的关键节点与数据指标。回答问题时结构严谨，案例详实，不仅阐述了\'做什么\'，更清晰地解释了\'为什么做\'以及\'如何衡量效果\'，表现出成熟的商业决策能力和风险控制意识。具备从0到1打造新品、稳定期精细化运营以及老品盘活的全周期操盘经验，是一位实战型人才。',
            highlights: '["具备成熟的数据驱动决策框架：面对产品去留、新品规划、库存管理等核心决策，均建立了量化的数据模型和验收标准（如CTR/CVR达标率、核心词排名潜力、退货率阈值、安全库存公式），避免了主观臆断，体现了高度的专业性和理性。","拥有从0到1打造新品的完整方法论：对新品前三个月的冷启动、爬坡、放量期有清晰规划，每个阶段目标明确、动作具体、验收标准量化，展现了极强的项目规划与节奏把控能力。","深入的用户洞察与差异化竞争策略：面对高壁垒市场（竞品高星级、高评论数），策略不是硬碰硬，而是通过系统化分析竞品差评挖掘细分痛点，并据此进行产品与流量（长尾词）的双重差异化，思路清晰且具备可操作性。","强大的风险管控与合规意识：在库存管理上建立了包含预警、应急、补救的完整断货应对机制；在合规上构建了\'事前预防-事中监控-事后整改\'的闭环体系，主动将风险控制嵌入运营全流程，而非被动应对。","优秀的复盘与优化迭代能力：在广告优化、老品诊断等环节，强调每日监控、每周复盘，并根据数据表现进行\'优胜劣汰\'的动态调整，表现出持续改进的运营思维。"]',
            potentialRisks: '["战略视野与宏观市场判断待验证：对话聚焦于具体运营执行层面，对于更宏观的市场趋势分析、品牌建设、跨平台战略等涉及较少。若岗位要求更高的战略规划能力，此方面需进一步考察。","团队管理与跨部门协作经验未体现：回答内容集中于个人专业操作，未提及如何领导团队、培训下属或与产品、供应链、市场等部门协同作战的经验，若岗位涉及管理职责，此为潜在短板。","对极端或复杂情况的应对深度：虽然提到了断货、积压、违规等风险的处理，但案例可能偏理想化。面对更复杂的供应链危机、重大平台政策突变或严重品牌危机时，其应对策略的深度和韧性有待在实际场景中检验。","可能过于依赖既有框架：候选人表现出对标准化流程的偏爱，在快速变化或需要颠覆性创新的环境中，其灵活性与创造性是否足够，需要结合具体业务场景评估。"]',
            factualContext: '["候选人曾在\\"瑞盈\\"（音）负责收纳类产品的运营，经历了产品从上线到稳定销售的全周期。","曾成功解决新品上线后第三周流量断层的挑战，通过调整广告策略（聚焦核心长尾词）、优化包装、申报Lightning Deal等手段，将产品从日销2-3单推至日销15-20单的稳定款。","在判断产品去留时，依赖三个核心数据维度：1）点击率与转化率是否达标（对比类目均值）；2）核心关键词广告排名是否有上升潜力；3）退货率与差评率是否可控。并设置两周的冲刺观察期。","对于从零开始的新品推广，规划了清晰的三阶段（冷启动期1-2周、增长爬坡期3-8周、稳定放量期9-12周），每个阶段有关键动作和量化的验收标准。","在库存与FBA管理上，采用数据驱动的安全库存模型（日均销量*补货周期+安全库存天数-现有库存-在途库存），并分淡旺季动态调整，建立监控看板。","对于新类目分析，会从市场容量、竞争格局、用户需求、利润空间四个维度进行数据化评估。","在广告活动管理上，采用\\"先精准测词，再逐步放量\\"的策略，搭建自动广告与手动广告（精准/短语/否定词）组合的结构，预算分配遵循\\"核心转化优先\\"原则，并进行日度监控和每周复盘优化。","在合规与风险控制上，建立了涵盖产品认证、Listing预审、日常监控、违规申诉与政策跟进的闭环管理体系。","对于接手老品，第一步是进行全维度数据诊断（流量、转化、品控、库存），找到核心症结后再制定优先级整改清单。"]',
            keywords: [
                { id: '2013126635914780673', keyword: '广告', count: 15, reportId: '2013126635767980033' },
                { id: '2013126636032221185', keyword: 'listing', count: 12, reportId: '2013126635767980033' },
                { id: '2013126636061581314', keyword: '产品', count: 11, reportId: '2013126635767980033' },
                { id: '2013126636095135746', keyword: '转化率', count: 8, reportId: '2013126635767980033' },
                { id: '2013126636128690177', keyword: '流量', count: 8, reportId: '2013126635767980033' },
                { id: '2013126636162244610', keyword: '核心', count: 8, reportId: '2013126635767980033' },
                { id: '2013126636191604738', keyword: '数据', count: 7, reportId: '2013126635767980033' },
                { id: '2013126636225159170', keyword: '类目', count: 7, reportId: '2013126635767980033' },
                { id: '2013126636258713601', keyword: '关键词', count: 7, reportId: '2013126635767980033' },
                { id: '2013126636292268033', keyword: '预算', count: 6, reportId: '2013126635767980033' },
                { id: '2013126636325822465', keyword: '差评', count: 6, reportId: '2013126635767980033' },
                { id: '2013126636359376897', keyword: '优化', count: 6, reportId: '2013126635767980033' },
                { id: '2013126636392931330', keyword: '库存', count: 5, reportId: '2013126635767980033' },
                { id: '2013126636422291458', keyword: '竞品', count: 5, reportId: '2013126635767980033' },
                { id: '2013126636455845889', keyword: '自然', count: 5, reportId: '2013126635767980033' },
                { id: '2013126636489400322', keyword: '排名', count: 4, reportId: '2013126635767980033' },
                { id: '2013126636518760450', keyword: '点击率', count: 4, reportId: '2013126635767980033' },
                { id: '2013126636548120578', keyword: '痛点', count: 4, reportId: '2013126635767980033' },
                { id: '2013126636581675009', keyword: '合规', count: 4, reportId: '2013126635767980033' },
                { id: '2013126636615229442', keyword: '销量', count: 3, reportId: '2013126635767980033' },
                { id: '2013126636644589569', keyword: '策略', count: 3, reportId: '2013126635767980033' },
                { id: '2013126636678144002', keyword: '成本', count: 3, reportId: '2013126635767980033' },
                { id: '2013126636711698433', keyword: '认证', count: 3, reportId: '2013126635767980033' },
                { id: '2013126636741058562', keyword: '维度', count: 3, reportId: '2013126635767980033' },
                { id: '2013126636774612994', keyword: '分析', count: 3, reportId: '2013126635767980033' },
                { id: '2013126636803973122', keyword: '精准', count: 3, reportId: '2013126635767980033' },
                { id: '2013126636833333249', keyword: '节点', count: 3, reportId: '2013126635767980033' },
                { id: '2013126636866887681', keyword: '评价', count: 3, reportId: '2013126635767980033' },
                { id: '2013126636900442114', keyword: '断货', count: 3, reportId: '2013126635767980033' },
                { id: '2013126636929802241', keyword: '利润率', count: 3, reportId: '2013126635767980033' }
            ]
        }
    }
]

// 节点AI打分列表 mock 数据（按节点ID组织）
// 节点提问分析 mock 数据列表
const nodeQuestionAnalysisList = [
    {
        nodeId: "-1000000026",
        data: {
            id: "2014996526696435714",
            nodeId: "2013106421600870401",
            assigneeId: "1973600648893194241",
            initialQuestions: "[\"聊聊你实习期间主动学习亚马逊运营最快的一个技能。\",\"如果遇到从没接触过的运营难题时，你第一反应是什么？\",\"我想了解在你完成这次关键词优化并应用于产品list前后，有没有去跟踪这些关键词带来的实际效果，比如流量、点击率或订单的变化，你是如何根据这些数据进行后续调整的？\",\"我想知道当你发现参数不一致时，除了联系供应商，有没有思考过如何从源头上避免这类问题再次发生？比如在后续的新品上架流程中，你是否有建立或者建议过什么检查机制或规范？\",\"那在你负责的sku里最满意的一次销售突破是怎么做到的？\",\"这个提升非常显著，除了性优化，你刚才还提到了精准引流和场景化营销，可以分别详细说明一下这两步你是如何操作的吗？例如在精准引流方面，你如何定位和触和触达目标客户？在场景化营销方面你又具体做了哪些工作？\",\"请说一下你处理过最棘手的客户售后问题是什么？当时第一反应是保护公司利益，还是很是客户体验？\",\"怎么判断该不该给客户退款？\",\"如果为了客户满意要自己额外加班，你心里会怎么想？\"]",
            followUpQuestions: "[\"你刚才提到了一个具体的操作流程。\",\"转化率从2.3%涨到了多少？\",\"刚刚那个帐篷的问题。处理的很好。在整个过程中你提到了联系供应商获取检测报告。\",\"继续刚才的说就行。\",\"Yeah.\"]",
            talkRatio: "{\"interviewer\":30,\"candidate\":70}",
            observations: "[\"引导性强\",\"逻辑严密\",\"追问深入\"]",
            tags: "[\"引导性强\",\"逻辑严密\",\"追问深入\",\"深挖细节\"]",
            comment: "面试官提问精准，追问环环相扣，能有效引导候选人展开细节，话语权分配合理，形成了高质量的深度对话。考察点覆盖完整，是一场结构严谨、效果出色的行为面试。",
            suggestions: "[{\"original_question\":\"当时第一反应是保护公司利益，还是很是客户体验？\",\"issue\":\"诱导性提问 - 问题预设了非此即彼的二元对立选项，暗示候选人必须在\\\"公司利益\\\"和\\\"客户体验\\\"之间做出一个选择，可能限制了候选人展示其更全面、平衡的思考方式。\",\"advice\":\"避免在问题中植入相互对立的选项，这会将候选人的思路框定在预设的范围内。更好的方式是询问候选人如何处理此类冲突，观察其如何自行定义和权衡这两个维度。\",\"improved_question\":\"在处理这类棘手的售后问题时，你是如何平衡公司利益和客户体验的？可以分享一下你的思考过程和决策标准吗？\"},{\"original_question\":\"如果为了客户满意要自己额外加班，你心里会怎么想？\",\"issue\":\"模糊不清 - 问题中的\\\"心里会怎么想\\\"过于主观和宽泛，容易引导候选人给出迎合性的、情绪化的回答（如\\\"我觉得是应该的\\\"），而非展示其具体的工作方法、优先级判断或问题解决能力。\",\"advice\":\"将问题从询问主观感受转向考察实际行为和决策逻辑。关注候选人如何评估加班的必要性、如何优化流程避免无效加班，以及如何平衡短期付出与长期收益。\",\"improved_question\":\"当遇到需要额外投入时间（比如加班）才能解决的客户问题时，你通常会如何判断其必要性和优先级？能否结合一个具体例子，说明你处理这类情况的过程和后续的复盘优化？\"}]",
            initialQuestionsList: [
                "聊聊你实习期间主动学习亚马逊运营最快的一个技能。",
                "如果遇到从没接触过的运营难题时，你第一反应是什么？",
                "我想了解在你完成这次关键词优化并应用于产品list前后，有没有去跟踪这些关键词带来的实际效果，比如流量、点击率或订单的变化，你是如何根据这些数据进行后续调整的？",
                "我想知道当你发现参数不一致时，除了联系供应商，有没有思考过如何从源头上避免这类问题再次发生？比如在后续的新品上架流程中，你是否有建立或者建议过什么检查机制或规范？",
                "那在你负责的sku里最满意的一次销售突破是怎么做到的？",
                "这个提升非常显著，除了性优化，你刚才还提到了精准引流和场景化营销，可以分别详细说明一下这两步你是如何操作的吗？例如在精准引流方面，你如何定位和触和触达目标客户？在场景化营销方面你又具体做了哪些工作？",
                "请说一下你处理过最棘手的客户售后问题是什么？当时第一反应是保护公司利益，还是很是客户体验？",
                "怎么判断该不该给客户退款？",
                "如果为了客户满意要自己额外加班，你心里会怎么想？"
            ],
            followUpQuestionsList: [
                "你刚才提到了一个具体的操作流程。",
                "转化率从2.3%涨到了多少？",
                "刚刚那个帐篷的问题。处理的很好。在整个过程中你提到了联系供应商获取检测报告。",
                "继续刚才的说就行。",
                "Yeah."
            ],
            talkRatioMap: {
                interviewer: 30,
                candidate: 70
            },
            observationsList: [
                "引导性强",
                "逻辑严密",
                "追问深入"
            ],
            tagsList: [
                "引导性强",
                "逻辑严密",
                "追问深入",
                "深挖细节"
            ],
            suggestionsList: [
                {
                    issue: "诱导性提问 - 问题预设了非此即彼的二元对立选项，暗示候选人必须在\"公司利益\"和\"客户体验\"之间做出一个选择，可能限制了候选人展示其更全面、平衡的思考方式。",
                    advice: "避免在问题中植入相互对立的选项，这会将候选人的思路框定在预设的范围内。更好的方式是询问候选人如何处理此类冲突，观察其如何自行定义和权衡这两个维度。",
                    original_question: "当时第一反应是保护公司利益，还是很是客户体验？",
                    improved_question: "在处理这类棘手的售后问题时，你是如何平衡公司利益和客户体验的？可以分享一下你的思考过程和决策标准吗？"
                },
                {
                    issue: "模糊不清 - 问题中的\"心里会怎么想\"过于主观和宽泛，容易引导候选人给出迎合性的、情绪化的回答（如\"我觉得是应该的\"），而非展示其具体的工作方法、优先级判断或问题解决能力。",
                    advice: "将问题从询问主观感受转向考察实际行为和决策逻辑。关注候选人如何评估加班的必要性、如何优化流程避免无效加班，以及如何平衡短期付出与长期收益。",
                    original_question: "如果为了客户满意要自己额外加班，你心里会怎么想？",
                    improved_question: "当遇到需要额外投入时间（比如加班）才能解决的客户问题时，你通常会如何判断其必要性和优先级？能否结合一个具体例子，说明你处理这类情况的过程和后续的复盘优化？"
                }
            ],
            coverageResult: null
        }
    },
    {
        nodeId: "-1000000027",
        data: {
            id: "2015002515411767297",
            nodeId: "2013106421600870402",
            assigneeId: "1973600648893194241",
            initialQuestions: "[\"看到你在瑞盈负责收纳类产品从上线到稳定销售整个周期里最大的挑战是什么？\",\"当时是怎么判断一个产品该继续投入还是应该砍掉的？\",\"如果现在让你从零开始推一个新品，你会怎么规划前三个月的关键节点？\",\"在产品进入稳定销售后，库存与fba管理变得尤为关键。你是如何制定补货计划以及处理可能出现的库存积压或断货风险的？\",\"如果现在给你一个全新的产品类目，你会从哪些数据维度开始分析？\",\"竞品普遍是4.5星以上，且评论数大于1000，这通常意味着什么？你会如何根据这些数据来制定自己的产品差异策略或进入策略？\",\"在完成产品差异化设计和上架后，广告活动管理是推动销量的核心。你通常如何更换和执行一个新品的广告活动？例如你会如何设置广告结构，预算分配，以及如何根据数据表现进行优化调整。\",\"在日常运营中，你是如何系统性的监控和应对产品合规问题？如认证安全标准非系统合规，如图文规范以及平台政策变化带来风险。\",\"那如果现在让你接手一个表面平平的老品，你的第一步动作会是什么呢？\"]",
            followUpQuestions: "[\"你刚才详细阐述了新品上架前三个月的完整规划，思路非常清晰。现在我们聊一聊亚马逊平台日常运营中的另一个重要环节。\",\"需要。\",\"你刚才完整的介绍了从挖掘痛点，筛选匹配方案到验证可行性的全流程，这非常系统。\",\"嗯，先不需要你刚才总结了广告优化的特殊情况处理，这非常实用。现在我们来谈谈亚马逊运营中另一个至关重要的环节，合规与风险控制。\"]",
            talkRatio: "{\"interviewer\":15,\"candidate\":85}",
            observations: "[\"提问逻辑清晰，层层递进\",\"能根据候选人回答灵活调整追问方向\",\"善于总结和引导话题\"]",
            tags: "[\"倾听者\",\"逻辑严密\",\"结构严谨\",\"灵活追问\"]",
            comment: "话语权15%体现了出色的倾听能力，首发与追问问题逻辑清晰，考察点覆盖全面。但需警惕过度沉默，必要时需主动打断以控制面试节奏。",
            suggestions: "[{\"original_question\":\"看到你在瑞盈负责收纳类产品从上线到稳定销售整个周期里最大的挑战是什么？\",\"issue\":\"模糊不清 - 问题范围过于宽泛，候选人可能不清楚应从哪个层面（市场、运营、供应链等）或哪个具体阶段来回答\\\"整个周期\\\"。\",\"advice\":\"建议将问题聚焦，可以拆解为针对产品生命周期中某个具体阶段的挑战，或者先请候选人简要概述周期，再追问具体阶段的挑战。这样能引导出更具体、更有深度的回答。\",\"improved_question\":\"在你负责收纳类产品从上线到稳定销售的完整周期中，能否先简要概述几个关键阶段？然后，请重点谈谈在'新品冷启动期'（如前4周），你遇到的最大挑战是什么？以及你是如何应对的？\"},{\"original_question\":\"如认证安全标准非系统合规，如图文规范以及平台政策变化带来风险带来的风险的。\",\"issue\":\"表达不清/口误 - 问题表述重复且存在语病（\\\"带来风险带来的风险的\\\"），可能让候选人感到困惑，无法准确理解面试官想问的具体是哪方面风险。\",\"advice\":\"面试官提问前应组织好语言，确保问题清晰、专业。可以将问题拆分为几个清晰的部分，或者用一个清晰的概括性问题引出话题。\",\"improved_question\":\"在日常运营中，你是如何系统性监控和应对产品合规风险的？请重点谈谈对产品认证安全标准、Listing图文规范，以及平台政策变化这三类风险的应对策略。\"}]",
            initialQuestionsList: [
                "看到你在瑞盈负责收纳类产品从上线到稳定销售整个周期里最大的挑战是什么？",
                "当时是怎么判断一个产品该继续投入还是应该砍掉的？",
                "如果现在让你从零开始推一个新品，你会怎么规划前三个月的关键节点？",
                "在产品进入稳定销售后，库存与fba管理变得尤为关键。你是如何制定补货计划以及处理可能出现的库存积压或断货风险的？",
                "如果现在给你一个全新的产品类目，你会从哪些数据维度开始分析？",
                "竞品普遍是4.5星以上，且评论数大于1000，这通常意味着什么？你会如何根据这些数据来制定自己的产品差异策略或进入策略？",
                "在完成产品差异化设计和上架后，广告活动管理是推动销量的核心。你通常如何更换和执行一个新品的广告活动？例如你会如何设置广告结构，预算分配，以及如何根据数据表现进行优化调整。",
                "在日常运营中，你是如何系统性的监控和应对产品合规问题？如认证安全标准非系统合规，如图文规范以及平台政策变化带来风险。",
                "那如果现在让你接手一个表面平平的老品，你的第一步动作会是什么呢？"
            ],
            followUpQuestionsList: [
                "你刚才详细阐述了新品上架前三个月的完整规划，思路非常清晰。现在我们聊一聊亚马逊平台日常运营中的另一个重要环节。",
                "需要。",
                "你刚才完整的介绍了从挖掘痛点，筛选匹配方案到验证可行性的全流程，这非常系统。",
                "嗯，先不需要你刚才总结了广告优化的特殊情况处理，这非常实用。现在我们来谈谈亚马逊运营中另一个至关重要的环节，合规与风险控制。"
            ],
            talkRatioMap: {
                interviewer: 15,
                candidate: 85
            },
            observationsList: [
                "提问逻辑清晰，层层递进",
                "能根据候选人回答灵活调整追问方向",
                "善于总结和引导话题"
            ],
            tagsList: [
                "倾听者",
                "逻辑严密",
                "结构严谨",
                "灵活追问"
            ],
            suggestionsList: [
                {
                    issue: "模糊不清 - 问题范围过于宽泛，候选人可能不清楚应从哪个层面（市场、运营、供应链等）或哪个具体阶段来回答\"整个周期\"。",
                    advice: "建议将问题聚焦，可以拆解为针对产品生命周期中某个具体阶段的挑战，或者先请候选人简要概述周期，再追问具体阶段的挑战。这样能引导出更具体、更有深度的回答。",
                    original_question: "看到你在瑞盈负责收纳类产品从上线到稳定销售整个周期里最大的挑战是什么？",
                    improved_question: "在你负责收纳类产品从上线到稳定销售的完整周期中，能否先简要概述几个关键阶段？然后，请重点谈谈在'新品冷启动期'（如前4周），你遇到的最大挑战是什么？以及你是如何应对的？"
                },
                {
                    issue: "表达不清/口误 - 问题表述重复且存在语病（\"带来风险带来的风险的\"），可能让候选人感到困惑，无法准确理解面试官想问的具体是哪方面风险。",
                    advice: "面试官提问前应组织好语言，确保问题清晰、专业。可以将问题拆分为几个清晰的部分，或者用一个清晰的概括性问题引出话题。",
                    original_question: "如认证安全标准非系统合规，如图文规范以及平台政策变化带来风险带来的风险的。",
                    improved_question: "在日常运营中，你是如何系统性监控和应对产品合规风险的？请重点谈谈对产品认证安全标准、Listing图文规范，以及平台政策变化这三类风险的应对策略。"
                }
            ],
            coverageResult: null
        }
    }
];

const processNodeAiScoreList = [
    {
        nodeId: "-1000000026",
        data: {
            id: "2013106421600870401",
            name: "HR面",
            comment: null,
            addEvaluations: null,
            nodeStatus: 2,
            aiResult: 2,
            assigneeId: "1973600648893194241",
            category: 5,
            processId: "2013106421462458370",
            prevId: null,
            abilities: [
                {
                    id: "2013106422087409665",
                    name: "持续成长与自我驱动",
                    description: null,
                    abilityId: "1965783074022965249",
                    abilityLevel: 3,
                    profileId: null,
                    abilityType: 0,
                    required: "1",
                    matchFlag: "0",
                    groupId: "1904446536984391682",
                    positionId: null,
                    groupName: null,
                    levelDescription: null,
                    score: 3.0,
                    aiScore: null,
                    aiScoreReason: null,
                    processId: "2013106421462458370",
                    nodeId: "2013106421600870401",
                    processTemplateId: null,
                    nodeTemplateId: null,
                    questions: [],
                    assessmentSubPoints: [],
                    profileAbilityId: null,
                    isAiScore: false,
                    isCovered: 1,
                    evaluationCriterias: [
                        {
                            id: "2011431038426755074",
                            abilityId: "1965783074022965249",
                            evaluationLevel: 1,
                            content: "在面试中表现出对前端技术（如框架、工具链）的更新缺乏了解，无法说出近期学习过的新知识或技术。"
                        },
                        {
                            id: "2011431038540001281",
                            abilityId: "1965783074022965249",
                            evaluationLevel: 1,
                            content: "描述过往项目时，仅满足于完成分配的任务，从未主动研究或引入更优的解决方案，工作方式一成不变。"
                        },
                        {
                            id: "2011431038565167106",
                            abilityId: "1965783074022965249",
                            evaluationLevel: 1,
                            content: "当被问及职业规划或个人技能提升计划时，回答模糊或表示没有具体规划，表现出安于现状、缺乏进取心的态度。"
                        },
                        {
                            id: "2011431038594527234",
                            abilityId: "1965783074022965249",
                            evaluationLevel: 2,
                            content: "能够清晰说明在过去半年内，通过阅读文档、教程或简单实践，掌握了至少一项与前端相关的新技术或工具（如一个新的UI库、构建工具特性）。"
                        },
                        {
                            id: "2011431038623887362",
                            abilityId: "1965783074022965249",
                            evaluationLevel: 2,
                            content: "在工作中遇到知识盲区时，会主动通过搜索引擎、官方文档或向同事请教来解决问题，并能在后续类似任务中独立应用所学。"
                        },
                        {
                            id: "2011431038649053186",
                            abilityId: "1965783074022965249",
                            evaluationLevel: 2,
                            content: "对个人技术发展有基本规划，例如希望深入某个前端框架或提升性能优化能力，并为此投入了规律的业余学习时间。"
                        },
                        {
                            id: "2011431038678413314",
                            abilityId: "1965783074022965249",
                            evaluationLevel: 3,
                            content: "不仅持续学习，还能系统性地构建知识体系（如撰写技术博客、制作学习笔记图谱），并能清晰阐述不同技术方案的选型逻辑与优劣对比。"
                        },
                        {
                            id: "2011431038707773442",
                            abilityId: "1965783074022965249",
                            evaluationLevel: 3,
                            content: "主动主导或深度参与过技术升级、架构优化等项目，能详细说明在推动过程中遇到的技术难点、解决方案以及带来的业务价值提升。"
                        },
                        {
                            id: "2011431038732939266",
                            abilityId: "1965783074022965249",
                            evaluationLevel: 3,
                            content: "展现出强烈的技术热情和影响力，例如在GitHub有高质量的开源贡献、在技术社区分享过经验、或在团队内主动组织技术分享带动他人学习。"
                        }
                    ],
                    aiComment: "候选人表现出强烈的主动学习意愿和快速掌握新技能的能力，能自发拆解复杂任务背后的逻辑，并通过工具辅助和对标分析实现能力跃迁。面对未知难题，其第一反应是系统性地获取知识、借鉴经验并输出可复用的方法论，体现出良好的自驱力和成长型思维。",
                    evidenceTexts: [
                        "我实习期间主动掌握最快的技能是亚马逊listing关键词精准埋词与搜索排名优化，从零基础到独立完成三款新品listing搭建，并实现七天内自然排名进入类目前200只用了十天时间。",
                        "最开始我发现带教师傅优化的listing核心关键词搜索排名远高于我们实习生随便堆砌的版本，就主动去拆解背后的逻辑。",
                        "我先花两天啃完了亚马逊官方的搜索术语优化指南，理清了标题五点描述产品描述search terms的权重规则。",
                        "接着用卖家精灵子鸟、数据魔方这两个工具，通过核心词拓展加竞品流量词8取加长尾词挖掘的组合方法，给一款户外水杯产品筛选出300加相关关键词。",
                        "后来我把这套方法整理成了一份listing关键词埋词sop分享给了同组的其他实习生，帮大家都缩短了listing优化的上手时间。",
                        "整个过程中我不会死磕，而是优先用数据加工具加同行经验的组合权，快速找到解决方向。",
                        "同时会把处理过程和结果整理成案例，方便后续遇到类似问题直接参考。",
                        "我还建议团队搭建了一个产品参数共享文档库，把所有在售产品的检测报告、参数清单上传到云端，所有运营同事都能随时查阅。"
                    ]
                },
                {
                    id: "2013106422213238785",
                    name: "目标力",
                    description: "考察一个人的目标感、制定目标的能力、分解目标的能力等方面",
                    abilityId: "1904449556790571009",
                    abilityLevel: 3,
                    profileId: null,
                    abilityType: 0,
                    required: "1",
                    matchFlag: "0",
                    groupId: "1904446537152163842",
                    positionId: null,
                    groupName: null,
                    levelDescription: null,
                    score: 5.0,
                    aiScore: null,
                    aiScoreReason: null,
                    processId: "2013106421462458370",
                    nodeId: "2013106421600870401",
                    processTemplateId: null,
                    nodeTemplateId: null,
                    questions: [],
                    assessmentSubPoints: [],
                    profileAbilityId: null,
                    isAiScore: false,
                    isCovered: 1,
                    evaluationCriterias: [],
                    aiComment: "候选人具备清晰的目标设定与执行推进能力，能够围绕关键业务指标设计可量化的行动路径，并通过数据监控与迭代优化确保目标达成。其工作方式呈现典型的'目标-策略-执行-反馈'闭环结构，在多个案例中均展示了从问题识别到结果验证的完整推导链条。",
                    evidenceTexts: [
                        "我不仅跟踪了数据，还基于数据做了两轮针对性调整，确保关键词优化的效果最大化。",
                        "第一步是搭建数据跟踪看板，我用亚马逊后台的业务报告和关键词排名工具，每天记录三类核心数据：一是目标关键词的自然排名，二是流量数据拆分，三是转化数据。",
                        "C p 2我还设置了七天为一个观察周期，避免单日数据波动带来的误判。",
                        "第一轮调整是在优化后的第七天，数据显示，核心词insulated water bottle 24 ounces的自然排名从之前的100家冲到了第18名，对应的自然流量涨了三倍，但转化率只有2.1%，低于类目平均的3.5%。",
                        "于是我调整了五点描述的结构，把核心卖点和关键词结合，比如把24 ounces insulated water bottle with leakproof lid放在第一条，补充保冷测试的真实场景。",
                        "第二轮调整在第14天，我发现长尾词leak proof water bottle for hiking的转化率高达5.2%，但排名一直在30名左右，流量占比只有8%，于是立即提升该词曝光。",
                        "调整后一周，这个长尾词的自然排名冲到了第12名，流量占比涨到22%，还带动了整体订单量再涨20%。",
                        "整个过程我都把数据变化和调整动作一一对应，整理成了关键词优化、数据跟踪、迭代调整的闭环文档。",
                        "后来公司上新的两款产品都复用了这套方法，新品破零时间缩短了一半。"
                    ]
                },
                {
                    id: "2013106422330679298",
                    name: "客户导向与责任担当",
                    description: null,
                    abilityId: "1965947646721736705",
                    abilityLevel: 3,
                    profileId: null,
                    abilityType: 0,
                    required: "1",
                    matchFlag: "0",
                    groupId: "1904446536984391682",
                    positionId: null,
                    groupName: null,
                    levelDescription: null,
                    score: 5.0,
                    aiScore: null,
                    aiScoreReason: null,
                    processId: "2013106421462458370",
                    nodeId: "2013106421600870401",
                    processTemplateId: null,
                    nodeTemplateId: null,
                    questions: [],
                    assessmentSubPoints: [],
                    profileAbilityId: null,
                    isAiScore: false,
                    isCovered: 1,
                    evaluationCriterias: [
                        {
                            id: "2011432784406458369",
                            abilityId: "1965947646721736705",
                            evaluationLevel: 1,
                            content: "在开发需求沟通中，忽视或误解业务方/用户（内部客户）的真实需求，仅按自己理解或技术便利性进行开发，导致最终成果与需求不符。"
                        },
                        {
                            id: "2011432784519704578",
                            abilityId: "1965947646721736705",
                            evaluationLevel: 1,
                            content: "当自己负责的模块出现线上Bug或故障时，推诿责任，认为是需求不清晰、测试不充分或他人修改导致，缺乏主动复盘和解决问题的意愿。"
                        },
                        {
                            id: "2011432784549064706",
                            abilityId: "1965947646721736705",
                            evaluationLevel: 1,
                            content: "在项目协作中，只关注完成自己分配的任务，对上下游环节（如产品、测试、后端）的进度或困难漠不关心，缺乏整体交付意识。"
                        },
                        {
                            id: "2011432784578424834",
                            abilityId: "1965947646721736705",
                            evaluationLevel: 2,
                            content: "能准确理解产品需求文档，主动与产品经理、设计师沟通确认细节，确保开发功能符合业务目标，并在规定时间内保质交付。"
                        },
                        {
                            id: "2011432784607784962",
                            abilityId: "1965947646721736705",
                            evaluationLevel: 2,
                            content: "对自己负责的代码质量有基本要求，当出现Bug时能及时响应、定位并修复，不推卸责任，并在团队内同步问题根因及解决方案。"
                        },
                        {
                            id: "2011432784632950786",
                            abilityId: "1965947646721736705",
                            evaluationLevel: 2,
                            content: "具备一定的项目主人翁意识，会关注自己开发功能的使用反馈，并愿意根据合理的优化建议进行后续迭代改进。"
                        },
                        {
                            id: "2011432784662310914",
                            abilityId: "1965947646721736705",
                            evaluationLevel: 3,
                            content: "主动深入业务场景，不仅能理解需求，更能从技术视角提出优化用户体验或提升业务效率的创新性建议，并被采纳实施。"
                        },
                        {
                            id: "2011432784687476738",
                            abilityId: "1965947646721736705",
                            evaluationLevel: 3,
                            content: "对线上问题有强烈的责任心，能主动建立监控、日志体系，并推动形成故障预防和快速响应机制，有效降低问题发生率和影响面。"
                        }
                    ],
                    aiComment: "候选人能够在维护客户体验与保障公司利益之间寻求理性平衡，面对高冲突情境时保持冷静与专业，坚持以证据为基础界定责任，并通过低成本高感知的解决方案传递服务诚意。其处理售后纠纷的方式体现了成熟的责任意识和长期主义视角。",
                    evidenceTexts: [
                        "当时我的第一反应是，在合规前提下平衡公司利益和客户体验，不是非此即彼的选择。",
                        "我没有直接反驳买家，而是先道歉：很抱歉给你带来了不好的使用体验，我们非常重视这个问题，会帮你妥善解决。",
                        "我把产品的第三方检测报告翻译成英文发给买家，圈出承重180斤的核心条款，再结合他提供的照片，客观说明此次断裂大概率是超承重使用导致的。",
                        "提出折中方案：可以给他补发一个全新的椅面配件，成本仅10美元，无需他退回旧件，运费由我们承担。",
                        "配件寄出后，我把物流单号发给买家，还附了一份正确使用和保养指南。",
                        "买家收到配件后，自己安装好了椅子，不仅撤销了a to z索赔的申请，还主动发来感谢信说没想到我们会这么负责。",
                        "后来我把这类售后案例整理成了跨境售后纠纷处理sop，明确了先取证再共情后折中的处理原则，帮团队减少了30%的无理由退款损失。",
                        "判断是否给客户退款，核心是以证据界定责任加结合店铺成本与绩效影响做权衡，不是一刀切。",
                        "我会把这些判断标准整理成退款决策清单，每次遇到售后纠纷，对照清单勾选就能快速做出决定，既不盲目让利，也不硬扛风险。"
                    ]
                }
            ],
            expAbilities: null,
            assignee: null,
            assigneeNickname: null,
            rawChat: null,
            chat: null,
            interviewTime: null,
            actualInterviewTime: "2026-01-19 12:29:30",
            companyName: null,
            positionName: null,
            candidateName: null,
            record: null,
            conclude: "掌握关键词优化与数据驱动运营，能通过系统化方法提升排名及转化，并建立可复用的流程规范。",
            aiConclusion: "1、总评：候选人在面试中展现了出色的自我驱动力、清晰的目标导向以及强烈的客户责任感，能够基于数据和工具进行系统性思考，并通过闭环迭代持续优化结果。其在亚马逊运营的多个关键环节（如关键词优化、广告投放、售后处理）均有扎实的实操经验和方法论沉淀，且具备从个体贡献向团队赋能延伸的能力。\n2、考察能力评估：在持续成长与自我驱动方面，候选人主动学习并快速掌握核心技能，善于复盘总结形成SOP，推动个人与团队共同进步；在目标力方面，能够围绕明确业务目标制定分阶段策略，利用数据分析定位问题，并动态调整执行路径以达成预期成果；在客户导向与责任担当方面，始终坚持客户体验与公司利益的平衡，在处理复杂售后时体现高度的责任意识与专业素养，同时注重流程优化预防风险。\n3、建议：综合表现优秀，建议进入下一轮面试或直接录用，尤其适合承担高自主性的运营岗位。",
            aiSuggestScore: null,
            score: 87.0,
            templateId: "2013078834543583234",
            interviewTemplateId: null,
            resumeAnalyses: null,
            expressionAnalyses: null,
            interviewInterval: 34,
            taskId: "89ee1017-2a76-47c1-b28e-fc1689120550",
            audioUrl: "https://ita-interview-test.oss-cn-shenzhen.aliyuncs.com/interview/process/2013106421462458370/nodes/2013106421600870401/recording.m4a",
            conversationId: null,
            interviewType: 1,
            jobCategoryIdentified: "亚马逊运营",
            diagnosedModel: "创业公司需要既能独立运营又认同'5个1'成长文化的自驱型人才",
            hasGeneratedTemplate: 0
        }
    },
    {
        nodeId: "-1000000027",
        data: {
            id: "2013106421600870401",
            name: "HR面",
            comment: null,
            addEvaluations: null,
            nodeStatus: 2,
            aiResult: 2,
            assigneeId: "1973600648893194241",
            category: 5,
            processId: "2013106421462458370",
            prevId: null,
            abilities: [
                {
                    id: "2013106422087409665",
                    name: "持续成长与自我驱动",
                    description: null,
                    abilityId: "1965783074022965249",
                    abilityLevel: 3,
                    profileId: null,
                    abilityType: 0,
                    required: "1",
                    matchFlag: "0",
                    groupId: "1904446536984391682",
                    positionId: null,
                    groupName: null,
                    levelDescription: null,
                    score: 3.0,
                    aiScore: null,
                    aiScoreReason: null,
                    processId: "2013106421462458370",
                    nodeId: "2013106421600870401",
                    processTemplateId: null,
                    nodeTemplateId: null,
                    questions: [],
                    assessmentSubPoints: [],
                    profileAbilityId: null,
                    isAiScore: false,
                    isCovered: 1,
                    evaluationCriterias: [],
                    aiComment: "候选人表现出强烈的主动学习意愿和快速掌握新技能的能力，能自发拆解复杂任务背后的逻辑，并通过工具辅助和对标分析实现能力跃迁。",
                    evidenceTexts: [
                        "我实习期间主动掌握最快的技能是亚马逊listing关键词精准埋词与搜索排名优化，从零基础到独立完成三款新品listing搭建，并实现七天内自然排名进入类目前200只用了十天时间。"
                    ]
                },
                {
                    id: "2013106422213238785",
                    name: "目标力",
                    description: "考察一个人的目标感、制定目标的能力、分解目标的能力等方面",
                    abilityId: "1904449556790571009",
                    abilityLevel: 3,
                    profileId: null,
                    abilityType: 0,
                    required: "1",
                    matchFlag: "0",
                    groupId: "1904446537152163842",
                    positionId: null,
                    groupName: null,
                    levelDescription: null,
                    score: 5.0,
                    aiScore: null,
                    aiScoreReason: null,
                    processId: "2013106421462458370",
                    nodeId: "2013106421600870401",
                    processTemplateId: null,
                    nodeTemplateId: null,
                    questions: [],
                    assessmentSubPoints: [],
                    profileAbilityId: null,
                    isAiScore: false,
                    isCovered: 1,
                    evaluationCriterias: [],
                    aiComment: "候选人具备清晰的目标设定与执行推进能力，能够围绕关键业务指标设计可量化的行动路径。",
                    evidenceTexts: [
                        "我不仅跟踪了数据，还基于数据做了两轮针对性调整，确保关键词优化的效果最大化。"
                    ]
                }
            ],
            expAbilities: null,
            assignee: null,
            assigneeNickname: null,
            rawChat: null,
            chat: null,
            interviewTime: null,
            actualInterviewTime: "2026-01-19 12:29:30",
            companyName: null,
            positionName: null,
            candidateName: null,
            record: null,
            conclude: "掌握关键词优化与数据驱动运营，能通过系统化方法提升排名及转化。",
            aiConclusion: "1、总评：候选人在面试中展现了出色的自我驱动力、清晰的目标导向以及强烈的客户责任感。\n2、考察能力评估：在持续成长与自我驱动方面，候选人主动学习并快速掌握核心技能。\n3、建议：综合表现优秀，建议进入下一轮面试或直接录用。",
            aiSuggestScore: null,
            score: 87.0,
            templateId: "2013078834543583234",
            interviewTemplateId: null,
            resumeAnalyses: null,
            expressionAnalyses: null,
            interviewInterval: 34,
            taskId: "89ee1017-2a76-47c1-b28e-fc1689120550",
            audioUrl: "https://ita-interview-test.oss-cn-shenzhen.aliyuncs.com/interview/process/2013106421462458370/nodes/2013106421600870401/recording.m4a",
            conversationId: null,
            interviewType: 1,
            jobCategoryIdentified: "亚马逊运营",
            diagnosedModel: "创业公司需要既能独立运营又认同'5个1'成长文化的自驱型人才",
            hasGeneratedTemplate: 0
        }
    }
]

export const mockInterviewStore = defineStore('mockInterviewStore', () => {
    // Mock数据是否启用
    const enabled = ref(true);

    // Mock流程数据缓存（列表/详情共用）
    const mockData = ref(null);

    // Mock候选人详情缓存（用于详情页/简历页等）
    const mockCandidateRes = ref(null);

    const shouldUseMock = computed(() => enabled.value);

    const parseUserInfo = () => {
        try {
            return JSON.parse(localStorage.getItem('userInfo') || '{}');
        } catch (e) {
            // localStorage 里可能是脏数据：忽略并按匿名用户处理
            console.warn('Failed to parse userInfo from localStorage:', e);
            return {};
        }
    };

    // 生成连续负数 mock id（字符串返回，便于与后端风格保持一致）
    const createMockIdFactory = () => {
        const base = -1000000000; // 固定起始负数
        let i = 0;
        return () => String(base - (i++));
    };

    const buildMockCandidateResponse = (idFactory) => {
        const candidateId = idFactory();
        const resumeId = idFactory();

        const tpl = mockCandidateResponseTemplate;

        const questions = (tpl?.data?.resume?.questions || []).map((q) => ({
            ...q,
            id: idFactory(),
            resumeId,
        }));

        const educations = (tpl?.data?.educations || []).map((e) => ({
            ...e,
            id: idFactory(),
            candidateId,
        }));

        const workExperiences = (tpl?.data?.workExperiences || []).map((w) => ({
            ...w,
            id: idFactory(),
            candidateId,
        }));

        const certifications = (tpl?.data?.certifications || []).map((c) => ({
            ...c,
            id: idFactory(),
            candidateId,
        }));

        const skills = (tpl?.data?.skills || []).map((s) => ({
            ...s,
            id: idFactory(),
            candidateId,
        }));

        const tags = (tpl?.data?.tags || []).map((t) => ({
            ...t,
            id: idFactory(),
        }));

        const jobPreference = tpl?.data?.jobPreference
            ? {
                ...tpl.data.jobPreference,
                id: idFactory(),
                candidateId,
            }
            : null;

        return {
            code: 200,
            msg: '操作成功',
            data: {
                ...tpl.data,
                id: candidateId,
                resumeId,
                resume: {
                    ...tpl.data.resume,
                    id: resumeId,
                    candidateId,
                    questions,
                },
                educations,
                workExperiences,
                projects: Array.isArray(tpl.data.projects) ? tpl.data.projects : [],
                jobPreference,
                certifications,
                skills,
                tags,
                // 避免超长 base64 进入仓库/运行内存
                avatarData: null,
            },
        };
    };

    const buildMockProcessData = (idFactory, userInfo, candidateRes) => {
        const userId = userInfo?.userId ?? null;
        const userName = userInfo?.nickName || 'Mock用户';
        const deptId = userInfo?.deptId || null;
        const deptName = userInfo?.deptName || 'Mock部门';

        const mockProcessId = idFactory();
        const mockNodeId1 = idFactory(); // HR面
        const mockNodeId2 = idFactory(); // 业务面
        const mockRecruitmentId = idFactory();
        const mockPositionId = idFactory();
        const mockProcessTemplateId = idFactory();
        const mockTemplateId1 = idFactory(); // HR面模板ID
        const mockTemplateId2 = idFactory(); // 业务面模板ID
        const mockTaskId1 = idFactory(); // HR面任务ID
        const mockTaskId2 = idFactory(); // 业务面任务ID

        // HR面 abilities IDs
        const mockAbilityId1 = idFactory(); // 持续成长与自我驱动
        const mockAbilityId2 = idFactory(); // 目标力
        const mockAbilityId3 = idFactory(); // 客户导向与责任担当

        // 业务面 abilities IDs
        const mockAbilityId4 = idFactory(); // 产品生命周期管理
        const mockAbilityId5 = idFactory(); // 数据分析力
        const mockAbilityId6 = idFactory(); // 亚马逊平台运营管理

        const mockAbilityTypeId1 = idFactory(); // 持续成长与自我驱动 abilityId
        const mockAbilityTypeId2 = idFactory(); // 目标力 abilityId
        const mockAbilityTypeId3 = idFactory(); // 客户导向与责任担当 abilityId
        const mockAbilityTypeId4 = idFactory(); // 产品生命周期管理 abilityId
        const mockAbilityTypeId5 = idFactory(); // 数据分析力 abilityId
        const mockAbilityTypeId6 = idFactory(); // 亚马逊平台运营管理 abilityId

        const mockGroupId1 = idFactory(); // 能力组ID 1
        const mockGroupId2 = idFactory(); // 能力组ID 2
        const mockGroupId3 = idFactory(); // 能力组ID 3

        const candidateId = candidateRes?.data?.id || idFactory();
        const candidateName = candidateRes?.data?.name || 'Mock候选人';

        // 生成 evaluationCriteria IDs（需要很多个）
        const evalCriteriaIds = Array.from({ length: 50 }, () => idFactory());

        return {
            id: String(mockProcessId),
            name: '亚马逊运营专员-纪锐钊',
            description: '',
            processNodes: [
                {
                    id: String(mockNodeId1),
                    name: 'HR面',
                    comment: null,
                    addEvaluations: null,
                    nodeStatus: 2,
                    aiResult: 2,
                    assigneeId: userId,
                    category: 5,
                    processId: String(mockProcessId),
                    prevId: null,
                    abilities: [
                        {
                            id: String(mockAbilityId1),
                            name: '持续成长与自我驱动',
                            description: null,
                            abilityId: String(mockAbilityTypeId1),
                            abilityLevel: 3,
                            profileId: null,
                            abilityType: 0,
                            required: '1',
                            matchFlag: '0',
                            groupId: String(mockGroupId1),
                            positionId: null,
                            groupName: null,
                            levelDescription: null,
                            score: 3.0,
                            aiScore: null,
                            aiScoreReason: null,
                            processId: String(mockProcessId),
                            nodeId: String(mockNodeId1),
                            processTemplateId: null,
                            nodeTemplateId: null,
                            questions: [],
                            assessmentSubPoints: [],
                            profileAbilityId: null,
                            isAiScore: false,
                            isCovered: 1,
                            evaluationCriterias: [
                                { id: String(evalCriteriaIds[0]), abilityId: String(mockAbilityTypeId1), evaluationLevel: 1, content: '在面试中表现出对前端技术（如框架、工具链）的更新缺乏了解，无法说出近期学习过的新知识或技术。' },
                                { id: String(evalCriteriaIds[1]), abilityId: String(mockAbilityTypeId1), evaluationLevel: 1, content: '描述过往项目时，仅满足于完成分配的任务，从未主动研究或引入更优的解决方案，工作方式一成不变。' },
                                { id: String(evalCriteriaIds[2]), abilityId: String(mockAbilityTypeId1), evaluationLevel: 1, content: '当被问及职业规划或个人技能提升计划时，回答模糊或表示没有具体规划，表现出安于现状、缺乏进取心的态度。' },
                                { id: String(evalCriteriaIds[3]), abilityId: String(mockAbilityTypeId1), evaluationLevel: 2, content: '能够清晰说明在过去半年内，通过阅读文档、教程或简单实践，掌握了至少一项与前端相关的新技术或工具（如一个新的UI库、构建工具特性）。' },
                                { id: String(evalCriteriaIds[4]), abilityId: String(mockAbilityTypeId1), evaluationLevel: 2, content: '在工作中遇到知识盲区时，会主动通过搜索引擎、官方文档或向同事请教来解决问题，并能在后续类似任务中独立应用所学。' },
                                { id: String(evalCriteriaIds[5]), abilityId: String(mockAbilityTypeId1), evaluationLevel: 2, content: '对个人技术发展有基本规划，例如希望深入某个前端框架或提升性能优化能力，并为此投入了规律的业余学习时间。' },
                                { id: String(evalCriteriaIds[6]), abilityId: String(mockAbilityTypeId1), evaluationLevel: 3, content: '不仅持续学习，还能系统性地构建知识体系（如撰写技术博客、制作学习笔记图谱），并能清晰阐述不同技术方案的选型逻辑与优劣对比。' },
                                { id: String(evalCriteriaIds[7]), abilityId: String(mockAbilityTypeId1), evaluationLevel: 3, content: '主动主导或深度参与过技术升级、架构优化等项目，能详细说明在推动过程中遇到的技术难点、解决方案以及带来的业务价值提升。' },
                                { id: String(evalCriteriaIds[8]), abilityId: String(mockAbilityTypeId1), evaluationLevel: 3, content: '展现出强烈的技术热情和影响力，例如在GitHub有高质量的开源贡献、在技术社区分享过经验、或在团队内主动组织技术分享带动他人学习。' },
                            ],
                            aiComment: '候选人表现出强烈的主动学习意愿和快速掌握新技能的能力，能自发拆解复杂任务背后的逻辑，并通过工具辅助和对标分析实现能力跃迁。面对未知难题，其第一反应是系统性地获取知识、借鉴经验并输出可复用的方法论，体现出良好的自驱力和成长型思维。',
                            evidenceTexts: [
                                '我实习期间主动掌握最快的技能是亚马逊listing关键词精准埋词与搜索排名优化，从零基础到独立完成三款新品listing搭建，并实现七天内自然排名进入类目前200只用了十天时间。',
                                '最开始我发现带教师傅优化的listing核心关键词搜索排名远高于我们实习生随便堆砌的版本，就主动去拆解背后的逻辑。',
                                '我先花两天啃完了亚马逊官方的搜索术语优化指南，理清了标题五点描述产品描述search terms的权重规则。',
                                '接着用卖家精灵子鸟、数据魔方这两个工具，通过核心词拓展加竞品流量词8取加长尾词挖掘的组合方法，给一款户外水杯产品筛选出300加相关关键词。',
                                '后来我把这套方法整理成了一份listing关键词埋词sop分享给了同组的其他实习生，帮大家都缩短了listing优化的上手时间。',
                                '整个过程中我不会死磕，而是优先用数据加工具加同行经验的组合权，快速找到解决方向。',
                                '同时会把处理过程和结果整理成案例，方便后续遇到类似问题直接参考。',
                                '我还建议团队搭建了一个产品参数共享文档库，把所有在售产品的检测报告、参数清单上传到云端，所有运营同事都能随时查阅。',
                            ],
                        },
                        {
                            id: String(mockAbilityId2),
                            name: '目标力',
                            description: '考察一个人的目标感、制定目标的能力、分解目标的能力等方面',
                            abilityId: String(mockAbilityTypeId2),
                            abilityLevel: 3,
                            profileId: null,
                            abilityType: 0,
                            required: '1',
                            matchFlag: '0',
                            groupId: String(mockGroupId2),
                            positionId: null,
                            groupName: null,
                            levelDescription: null,
                            score: 5.0,
                            aiScore: null,
                            aiScoreReason: null,
                            processId: String(mockProcessId),
                            nodeId: String(mockNodeId1),
                            processTemplateId: null,
                            nodeTemplateId: null,
                            questions: [],
                            assessmentSubPoints: [],
                            profileAbilityId: null,
                            isAiScore: false,
                            isCovered: 1,
                            evaluationCriterias: [],
                            aiComment: '候选人具备清晰的目标设定与执行推进能力，能够围绕关键业务指标设计可量化的行动路径，并通过数据监控与迭代优化确保目标达成。其工作方式呈现典型的"目标-策略-执行-反馈"闭环结构，在多个案例中均展示了从问题识别到结果验证的完整推导链条。',
                            evidenceTexts: [
                                '我不仅跟踪了数据，还基于数据做了两轮针对性调整，确保关键词优化的效果最大化。',
                                '第一步是搭建数据跟踪看板，我用亚马逊后台的业务报告和关键词排名工具，每天记录三类核心数据：一是目标关键词的自然排名，二是流量数据拆分，三是转化数据。',
                                'C p 2我还设置了七天为一个观察周期，避免单日数据波动带来的误判。',
                                '第一轮调整是在优化后的第七天，数据显示，核心词insulated water bottle 24 ounces的自然排名从之前的100家冲到了第18名，对应的自然流量涨了三倍，但转化率只有2.1%，低于类目平均的3.5%。',
                                '于是我调整了五点描述的结构，把核心卖点和关键词结合，比如把24 ounces insulated water bottle with leakproof lid放在第一条，补充保冷测试的真实场景。',
                                '第二轮调整在第14天，我发现长尾词leak proof water bottle for hiking的转化率高达5.2%，但排名一直在30名左右，流量占比只有8%，于是立即提升该词曝光。',
                                '调整后一周，这个长尾词的自然排名冲到了第12名，流量占比涨到22%，还带动了整体订单量再涨20%。',
                                '整个过程我都把数据变化和调整动作一一对应，整理成了关键词优化、数据跟踪、迭代调整的闭环文档。',
                                '后来公司上新的两款产品都复用了这套方法，新品破零时间缩短了一半。',
                            ],
                        },
                        {
                            id: String(mockAbilityId3),
                            name: '客户导向与责任担当',
                            description: null,
                            abilityId: String(mockAbilityTypeId3),
                            abilityLevel: 3,
                            profileId: null,
                            abilityType: 0,
                            required: '1',
                            matchFlag: '0',
                            groupId: String(mockGroupId1),
                            positionId: null,
                            groupName: null,
                            levelDescription: null,
                            score: 5.0,
                            aiScore: null,
                            aiScoreReason: null,
                            processId: String(mockProcessId),
                            nodeId: String(mockNodeId1),
                            processTemplateId: null,
                            nodeTemplateId: null,
                            questions: [],
                            assessmentSubPoints: [],
                            profileAbilityId: null,
                            isAiScore: false,
                            isCovered: 1,
                            evaluationCriterias: [
                                { id: String(evalCriteriaIds[9]), abilityId: String(mockAbilityTypeId3), evaluationLevel: 1, content: '在开发需求沟通中，忽视或误解业务方/用户（内部客户）的真实需求，仅按自己理解或技术便利性进行开发，导致最终成果与需求不符。' },
                                { id: String(evalCriteriaIds[10]), abilityId: String(mockAbilityTypeId3), evaluationLevel: 1, content: '当自己负责的模块出现线上Bug或故障时，推诿责任，认为是需求不清晰、测试不充分或他人修改导致，缺乏主动复盘和解决问题的意愿。' },
                                { id: String(evalCriteriaIds[11]), abilityId: String(mockAbilityTypeId3), evaluationLevel: 1, content: '在项目协作中，只关注完成自己分配的任务，对上下游环节（如产品、测试、后端）的进度或困难漠不关心，缺乏整体交付意识。' },
                                { id: String(evalCriteriaIds[12]), abilityId: String(mockAbilityTypeId3), evaluationLevel: 2, content: '能准确理解产品需求文档，主动与产品经理、设计师沟通确认细节，确保开发功能符合业务目标，并在规定时间内保质交付。' },
                                { id: String(evalCriteriaIds[13]), abilityId: String(mockAbilityTypeId3), evaluationLevel: 2, content: '对自己负责的代码质量有基本要求，当出现Bug时能及时响应、定位并修复，不推卸责任，并在团队内同步问题根因及解决方案。' },
                                { id: String(evalCriteriaIds[14]), abilityId: String(mockAbilityTypeId3), evaluationLevel: 2, content: '具备一定的项目主人翁意识，会关注自己开发功能的使用反馈，并愿意根据合理的优化建议进行后续迭代改进。' },
                                { id: String(evalCriteriaIds[15]), abilityId: String(mockAbilityTypeId3), evaluationLevel: 3, content: '主动深入业务场景，不仅能理解需求，更能从技术视角提出优化用户体验或提升业务效率的创新性建议，并被采纳实施。' },
                                { id: String(evalCriteriaIds[16]), abilityId: String(mockAbilityTypeId3), evaluationLevel: 3, content: '对线上问题有强烈的责任心，能主动建立监控、日志体系，并推动形成故障预防和快速响应机制，有效降低问题发生率和影响面。' },
                            ],
                            aiComment: '候选人能够在维护客户体验与保障公司利益之间寻求理性平衡，面对高冲突情境时保持冷静与专业，坚持以证据为基础界定责任，并通过低成本高感知的解决方案传递服务诚意。其处理售后纠纷的方式体现了成熟的责任意识和长期主义视角。',
                            evidenceTexts: [
                                '当时我的第一反应是，在合规前提下平衡公司利益和客户体验，不是非此即彼的选择。',
                                '我没有直接反驳买家，而是先道歉：很抱歉给你带来了不好的使用体验，我们非常重视这个问题，会帮你妥善解决。',
                                '我把产品的第三方检测报告翻译成英文发给买家，圈出承重180斤的核心条款，再结合他提供的照片，客观说明此次断裂大概率是超承重使用导致的。',
                                '提出折中方案：可以给他补发一个全新的椅面配件，成本仅10美元，无需他退回旧件，运费由我们承担。',
                                '配件寄出后，我把物流单号发给买家，还附了一份正确使用和保养指南。',
                                '买家收到配件后，自己安装好了椅子，不仅撤销了a to z索赔的申请，还主动发来感谢信说没想到我们会这么负责。',
                                '后来我把这类售后案例整理成了跨境售后纠纷处理sop，明确了先取证再共情后折中的处理原则，帮团队减少了30%的无理由退款损失。',
                                '判断是否给客户退款，核心是以证据界定责任加结合店铺成本与绩效影响做权衡，不是一刀切。',
                                '我会把这些判断标准整理成退款决策清单，每次遇到售后纠纷，对照清单勾选就能快速做出决定，既不盲目让利，也不硬扛风险。',
                            ],
                        },
                    ],
                    expAbilities: null,
                    assignee: userId
                        ? {
                            userId,
                            nickName: userName,
                            deptId,
                            deptName,
                        }
                        : null,
                    assigneeNickname: null,
                    rawChat: null,
                    chat: null,
                    interviewTime: null,
                    actualInterviewTime: dayjs().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
                    companyName: null,
                    positionName: null,
                    candidateName: null,
                    record: null,
                    conclude: '掌握关键词优化与数据驱动运营，能通过系统化方法提升排名及转化，并建立可复用的流程规范。',
                    aiConclusion: '1、总评：候选人在面试中展现了出色的自我驱动力、清晰的目标导向以及强烈的客户责任感，能够基于数据和工具进行系统性思考，并通过闭环迭代持续优化结果。其在亚马逊运营的多个关键环节（如关键词优化、广告投放、售后处理）均有扎实的实操经验和方法论沉淀，且具备从个体贡献向团队赋能延伸的能力。\n2、考察能力评估：在持续成长与自我驱动方面，候选人主动学习并快速掌握核心技能，善于复盘总结形成SOP，推动个人与团队共同进步；在目标力方面，能够围绕明确业务目标制定分阶段策略，利用数据分析定位问题，并动态调整执行路径以达成预期成果；在客户导向与责任担当方面，始终坚持客户体验与公司利益的平衡，在处理复杂售后时体现高度的责任意识与专业素养，同时注重流程优化预防风险。\n3、建议：综合表现优秀，建议进入下一轮面试或直接录用，尤其适合承担高自主性的运营岗位。',
                    aiSuggestScore: null,
                    score: 87.0,
                    templateId: String(mockTemplateId1),
                    interviewTemplateId: null,
                    resumeAnalyses: null,
                    expressionAnalyses: null,
                    interviewInterval: 34,
                    taskId: String(mockTaskId1),
                    audioUrl: 'https://ita-interview-test.oss-cn-shenzhen.aliyuncs.com/interview/process/mock/recording.m4a',
                    conversationId: null,
                    interviewType: 1,
                    jobCategoryIdentified: '亚马逊运营',
                    diagnosedModel: '创业公司需要既能独立运营又认同\'5个1\'成长文化的自驱型人才',
                    hasGeneratedTemplate: 0,
                },
                {
                    id: String(mockNodeId2),
                    name: '业务面',
                    comment: null,
                    addEvaluations: null,
                    nodeStatus: 2,
                    aiResult: 2,
                    assigneeId: userId,
                    category: 5,
                    processId: String(mockProcessId),
                    prevId: String(mockNodeId1),
                    abilities: [
                        {
                            id: String(mockAbilityId4),
                            name: '产品生命周期管理',
                            description: null,
                            abilityId: String(mockAbilityTypeId4),
                            abilityLevel: 3,
                            profileId: null,
                            abilityType: 0,
                            required: '1',
                            matchFlag: '0',
                            groupId: String(mockGroupId3),
                            positionId: null,
                            groupName: null,
                            levelDescription: null,
                            score: 3.0,
                            aiScore: null,
                            aiScoreReason: null,
                            processId: String(mockProcessId),
                            nodeId: String(mockNodeId2),
                            processTemplateId: null,
                            nodeTemplateId: null,
                            questions: [],
                            assessmentSubPoints: [],
                            profileAbilityId: null,
                            isAiScore: false,
                            isCovered: 1,
                            evaluationCriterias: [],
                            aiComment: '候选人展示了对产品生命周期各阶段的深刻理解，能够将产品发展划分为明确的阶段（冷启动期、增长爬坡期、稳定放量期），并为每个阶段设定具体的目标、关键动作和可量化的验收标准。其决策逻辑基于数据表现而非主观判断，体现了科学管理和风险控制意识。',
                            evidenceTexts: [
                                '如果让我从零开始推一款亚马逊收纳类新品，前三个月会按冷启动期、增长爬坡期、稳定放量期三个阶段划分关键节点，每个阶段聚焦核心目标，用数据驱动动作。',
                                '第一阶段第1到2周冷启动期，夯实基础，精准测款，核心目标是完成listing精细化搭建、关键词测试和初始评价积累，避免无效曝光。',
                                '第二阶段第3到8周增长爬坡期，放大流量优化转化，核心目标是提升核心关键词排名，降低acos，实现日单量稳步增长。',
                                '第三阶段第9到12周稳定放量期，维稳增效，打造小爆款，核心目标是提升自然流量占比，降低广告依赖，实现利润最大化。',
                                '每个阶段都有明确的验收标准，例如冷启动期要求listing cpr大于等于类目均值的1.1倍，crr大于等于类目均值；增长爬坡期要求核心词自然排名进入类目前50，acos控制在25%以内；稳定放量期要求自然流量占比大于等于60%，利润率大于等于20%。',
                                '整个三个月的规划核心是先精准测款，再逐步放量，最后维稳增效，避免盲目投入。',
                            ],
                        },
                        {
                            id: String(mockAbilityId5),
                            name: '数据分析力',
                            description: '',
                            abilityId: String(mockAbilityTypeId5),
                            abilityLevel: 3,
                            profileId: null,
                            abilityType: 0,
                            required: '1',
                            matchFlag: '0',
                            groupId: String(mockGroupId3),
                            positionId: null,
                            groupName: null,
                            levelDescription: null,
                            score: 5.0,
                            aiScore: null,
                            aiScoreReason: null,
                            processId: String(mockProcessId),
                            nodeId: String(mockNodeId2),
                            processTemplateId: null,
                            nodeTemplateId: null,
                            questions: [],
                            assessmentSubPoints: [],
                            profileAbilityId: null,
                            isAiScore: false,
                            isCovered: 1,
                            evaluationCriterias: [],
                            aiComment: '候选人表现出极强的数据分析能力，能够围绕业务问题构建多维度的数据分析框架，并通过设定量化指标支持决策。其分析不仅限于数据呈现，更能结合业务场景解释数据背后的原因，并据此制定针对性策略。',
                            evidenceTexts: [
                                '面对全新的产品类目，我会从市场容量、竞争格局、用户需求、利润空间四个核心维度切入，用数据验证类目可行性，避免盲目入场。',
                                '市场容量维度看类目整体销量环比增长率是否大于等于10%，top 100商品的日均总销量是否足够高，以及新品上架小于等于6个月的占比是否大于等于20%。',
                                '竞争格局维度计算top 10商品销量占比，若小于等于50%说明类目分散有机会；同时分析竞品定价区间、评分星级、评论数及核心关键词cpc均值。',
                                '用户需求维度批量抓取top 50竞品的1到3星差评，统计高频吐槽点作为差异化机会；分析买家搜索词和qa高频问题指导listing优化。',
                                '利润空间维度核算单件利润公式，验证类目平均利润率是否大于等于20%，fba费用加广告费占比是否小于等于售价的30%，并评估资金周转周期。',
                                '对于老品诊断，拆解流量、转化、品控、库存四个维度数据，如自然流量占比低于40%且核心词排名掉出前200则判定为权重下滑，差评率超过3%则需优先解决品控问题。',
                            ],
                        },
                        {
                            id: String(mockAbilityId6),
                            name: '亚马逊平台运营管理',
                            description: null,
                            abilityId: String(mockAbilityTypeId6),
                            abilityLevel: 3,
                            profileId: null,
                            abilityType: 0,
                            required: '1',
                            matchFlag: '0',
                            groupId: String(mockGroupId3),
                            positionId: null,
                            groupName: null,
                            levelDescription: null,
                            score: 3.0,
                            aiScore: null,
                            aiScoreReason: null,
                            processId: String(mockProcessId),
                            nodeId: String(mockNodeId2),
                            processTemplateId: null,
                            nodeTemplateId: null,
                            questions: [],
                            assessmentSubPoints: [],
                            profileAbilityId: null,
                            isAiScore: false,
                            isCovered: 1,
                            evaluationCriterias: [],
                            aiComment: '候选人对亚马逊平台的核心运营模块有全面且深入的理解，涵盖广告管理、库存与FBA补货、合规风控等多个方面，具备从战略规划到细节执行的全流程操作能力，方法论成熟且具有可复制性。',
                            evidenceTexts: [
                                '新品广告活动采用自动加手动组合分层测试结构，搭建一个自动广告组加三个手动广告组（精准词、短语词、否定词），各司其职互不干扰。',
                                '预算分配遵循70%投核心转化、20%投潜力拓展、10%投测试探索的原则，初期重点保障高转化词曝光，后期逐步压缩广告预算至销售额的10%到15%。',
                                '制定FBA补货计划时采用数据驱动的安全库存模型，综合考虑日均销量、补货周期、安全库存天数，并设置淡旺季动态调整机制，旺季预留海运加空派双通道应急。',
                                '建立库存监控看板，每周复盘现有库存可售天数、在途进度、fba入库时效，偏差超10%即修正参数。',
                                '处理断货风险时设置库存预警线，应急措施包括切换头程物流方式（海运改空派）、开启预售模式，并在补货后通过精准广告和优惠券快速恢复排名。',
                                '应对库存积压采取轻库存策略，区分季节性与非季节性滞销，分别采用折扣捆绑、站外清仓或移除转卖等方式去库存。',
                                '合规管理上构建事前预防、事中监控、事后整改闭环体系，事前核查产品认证并建立合规档案，事中每日巡检listing状态与客户反馈，事后标准化申诉流程并将案例纳入风险库。',
                            ],
                        },
                    ],
                    expAbilities: null,
                    assignee: userId
                        ? {
                            userId,
                            nickName: userName,
                            deptId,
                            deptName,
                        }
                        : null,
                    assigneeNickname: null,
                    rawChat: null,
                    chat: null,
                    interviewTime: null,
                    actualInterviewTime: dayjs().subtract(1, 'day').add(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
                    companyName: null,
                    positionName: null,
                    candidateName: null,
                    record: null,
                    conclude: '候选人系统阐述了新品推广、库存管理、广告优化及合规风控的全流程，数据驱动决策，逻辑清晰，具备成熟运营方法论。',
                    aiConclusion: '1、总评：候选人在面试中展现出系统化、数据驱动的亚马逊运营思维，对产品从新品冷启动到稳定期管理的全周期有清晰的规划，并能结合具体案例进行阐述，逻辑严谨，专业度高。\n2、考察能力评估：在产品生命周期管理方面，候选人能够分阶段制定目标并设定量化验收标准，体现出较强的策略规划能力；在数据分析力方面，候选人熟练运用多维度数据进行决策判断，具备敏锐的数据洞察与落地应用能力；在亚马逊平台运营管理方面，候选人对广告架构、库存控制、合规风控等核心模块均有扎实的实操经验，方法论完整且可执行性强。\n3、建议：建议进入下一轮面试，进一步考察其团队协作与跨部门沟通能力。',
                    aiSuggestScore: null,
                    score: 73.0,
                    templateId: String(mockTemplateId2),
                    interviewTemplateId: null,
                    resumeAnalyses: null,
                    expressionAnalyses: null,
                    interviewInterval: 39,
                    taskId: String(mockTaskId2),
                    audioUrl: 'https://ita-interview-test.oss-cn-shenzhen.aliyuncs.com/interview/process/mock/recording.m4a',
                    conversationId: null,
                    interviewType: 0,
                    jobCategoryIdentified: '亚马逊运营专员',
                    diagnosedModel: '初创SaaS公司内部孵化跨境电商业务，需要从0到1建立运营体系',
                    hasGeneratedTemplate: 0,
                },
            ],
            processProfile: null,
            candidateId: String(candidateId),
            recruitmentProcessId: null,
            candidate: {
                id: String(candidateId),
                name: candidateName,
            },
            profileId: null,
            processStatus: 1,
            comment: null,
            score: 80.0,
            positionId: null,
            recruitmentId: String(mockRecruitmentId),
            recruitment: {
                id: String(mockRecruitmentId),
                positionId: String(mockPositionId),
                positionProfileId: null,
                batchId: null,
                positionProfile: null,
                name: '亚马逊运营专员',
                dateNeeded: null,
                deadline: null,
                reason: null,
                numNeeded: 0,
                numApplied: 1,
                numInterviewed: 1,
                numQualified: 1,
                numUnqualified: 0,
                numHired: null,
                numUnfilled: null,
                urgency: 0,
                difficulty: 0,
                jobTitle: '亚马逊运营专员',
                jobDuty:
                    '1. 负责亚马逊店铺的日常运营管理，包括产品上架、Listing优化（标题、关键词、图片、A+页面）、价格策略制定及库存监控\n2. 独立操作亚马逊CPC广告 campaigns，进行关键词研究、出价调整和效果数据分析，持续优化ACOS\n3. 运用FBA库存管理，制定补货计划，避免断货或滞销，降低仓储成本\n4. 监测店铺销售数据、竞争对手动态及市场趋势，通过Excel数据透视分析输出运营报告\n5. 处理客户咨询与售后问题，维护店铺好评率，降低退货率和ODR指标',
                jobRequirement:
                    '必备项：\n1. 具备1年以上亚马逊精品运营经验，熟悉平台政策和操作流程\n2. 能熟练使用Excel进行数据透视分析及VLOOKUP函数处理\n3. 掌握CPC广告优化技巧，有降低ACOS的实际操作经验\n4. 具备较强的数据分析能力和市场敏感度，能独立制定运营策略\n\n加分项：\n1. 有3C类目爆款打造经验者优先\n2. 熟悉Helium 10/Jungle Scout等选品工具者优先\n3. 英语CET-4及以上，能独立处理英文客服邮件者优先',
                jobWelfare: [],
                jobDevelopment: null,
                requesterUserId: null,
                jobKeywords: ['亚马逊运营', 'CPC广告优化', 'FBA库存管理', 'Listing优化', '数据分析', 'ACOS', '精品运营'],
                standard: null,
                greetingMessage: null,
                finishFlag: 0,
                demandSource: 0,
                processTemplateId: String(mockProcessTemplateId),
                processTemplateVo: null,
                finishDate: null,
                createBy: userId,
                creator: null,
                requesterUser: null,
                createTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                jobSyncVo: null,
                jobSyncs: null,
                encryptId: null,
                filterConditions: null,
                report: null,
                remoteTask: null,
                queryKeywords: {
                    job: '亚马逊运营专员',
                    address: '深圳',
                    experience: '1-3年',
                    education: '大专',
                },
                delayDay: null,
                entryCount: 0,
                hiringGap: 0,
                hasRisk: false,
                processCount: 0,
            },
            roundsPassed: 2,
            reportId: null,
            templateId: String(mockProcessTemplateId),
            remarkCount: 0,
            remarks: [{ content: '' }],
            offerStatus: 0,
            entryStatus: null,
            createBy: userId,
            createTime: dayjs().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
            updateBy: userId,
            updateTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            isMock: true,
        };
    };

    // 第一步：生成 mock（流程 + 候选人）
    const generateMockData = () => {
        const userInfo = parseUserInfo();
        const idFactory = createMockIdFactory();

        const candidateRes = buildMockCandidateResponse(idFactory);
        const process = buildMockProcessData(idFactory, userInfo, candidateRes);

        mockCandidateRes.value = candidateRes;
        mockData.value = process;

        return { process, candidateRes };
    };

    // 流程 mock（列表/详情用）
    const getMockData = () => {
        if (mockData.value) return mockData.value;
        return generateMockData().process;
    };

    // 候选人 mock（简历/候选人详情用）
    const getMockCandidateRes = () => {
        if (mockCandidateRes.value) return mockCandidateRes.value;
        return generateMockData().candidateRes;
    };

    const insertMockDataToFirst = (list = []) => {
        if (!shouldUseMock.value) return list;
        const m = getMockData();
        const filtered = Array.isArray(list) ? list.filter((item) => item?.isMock !== true) : [];
        return [m, ...filtered];
    };

    const isMockData = (item) => item?.isMock === true;

    const clearMockData = () => {
        mockData.value = null;
        mockCandidateRes.value = null;
    };

    const setEnabled = (val) => {
        enabled.value = !!val;
        if (!enabled.value) {
            clearMockData();
        }
    };

    /**
     * 生成面试排名 mock 数据
     * @param {string} processId 流程ID
     * @param {string} candidateId 候选人ID
     * @param {string} candidateName 候选人姓名
     * @param {number} type 排名类型，0-全部，1-已通过
     * @param {number} processStatus 流程状态，可选
     * @param {number} matchScore 匹配分数，可选
     * @returns {object} 面试排名数据
     */
    const getMockCandidateRank = (processId, candidateId, candidateName, type = 0, processStatus = null, matchScore = null) => {
        const process = getMockData();
        const candidate = getMockCandidateRes();

        // 使用传入的 processId 和 candidateId，如果没有则使用 mock 数据中的
        const finalProcessId = processId || process?.id;
        const finalCandidateId = candidateId || candidate?.data?.id;
        const finalCandidateName = candidateName || candidate?.data?.name || '纪锐钊';

        // 优先使用传入的值，否则从 mock 数据中获取 processStatus 和 matchScore
        const finalProcessStatus = processStatus !== null ? processStatus : (process?.processStatus || 1);
        const finalMatchScore = matchScore !== null ? matchScore : (process?.score || candidate?.data?.score || 80.0);

        return {
            code: 200,
            msg: '操作成功',
            data: {
                rangeDetail: [
                    {
                        processId: String(finalProcessId),
                        candidateId: String(finalCandidateId),
                        matchScore: finalMatchScore,
                        candidateName: finalCandidateName,
                        range: 1,
                        processStatus: finalProcessStatus
                    }
                ],
                total: 1,
                range: 1,
                type: type,
                processStatus: finalProcessStatus,
                matchScore: finalMatchScore
            }
        };
    };

    /**
     * 生成猜你想问 mock 数据
     * @param {string} processId 流程ID
     * @returns {object} 猜你想问数据
     */
    const getMockProcessSuggestQuestion = (processId) => {
        // 使用传入的 processId，如果没有则使用 mock 数据中的
        const finalProcessId = processId || getMockData()?.id;

        // 生成固定的 mock ID
        const mockId = '-2013127323554144257';

        const questions = [
            "一个园林专业、行政出身的实习生，能扛住真实亚马逊的生死压力吗？",
            "他所有成功都来自实习生保护伞，你敢赌他独立面对亏损吗？",
            "极度依赖SOP的流程专家，在亚马逊黑天鹅事件中会僵化吗？"
        ];

        return {
            code: 200,
            msg: '操作成功',
            data: {
                id: mockId,
                questions: JSON.stringify(questions),
                processId: String(finalProcessId),
                generateStatus: 1
            }
        };
    };

    /**
     * 生成面试总结 mock 数据
     * @param {string} processId 流程ID
     * @returns {object} 面试总结数据
     */
    const getMockProcessSummaryGenerateLatest = (processId) => {
        // 使用传入的 processId，如果没有则使用 mock 数据中的
        const finalProcessId = processId || getMockData()?.id;

        // 生成固定的 mock ID
        const mockId = '-2013126782212104194';

        return {
            code: 200,
            msg: '操作成功',
            data: {
                id: mockId,
                processId: String(finalProcessId),
                executiveSummary: {
                    assessmentSummary: "候选人与亚马逊运营岗位高度匹配，具备从执行到复盘优化的完整能力闭环。其数据驱动的结构化思维、风险管控意识及主动沉淀SOP的习惯，预示其能快速胜任运营工作并成为团队效率贡献者。预测其能在短期内独立负责产品线，并具备成长为业务骨干的潜力。",
                    coreStrengths: [
                        {
                            title: "卓越的结构化思维与问题解决能力",
                            description: "能系统性拆解运营难题（如广告优化、违规申诉），采用'数据定位+工具辅助+对标参考'方法论，形成分析、执行、验证的完整闭环，远超实习生水平。"
                        },
                        {
                            title: "强大的数据驱动与迭代优化意识",
                            description: "在关键词优化、广告投放等环节，注重数据跟踪与效果验证，通过搭建看板、多轮调整将经验沉淀为可复用文档，体现了成熟的运营思维。"
                        },
                        {
                            title: "主动的流程优化与风险管控能力",
                            description: "不止于解决问题，更擅长从源头预防。曾主动建立'新品上架三审机制'、库存预警模型及合规闭环体系，有效降低团队错误率与业务风险。"
                        },
                        {
                            title: "成熟的客户与商业利益平衡智慧",
                            description: "处理售后纠纷时，能坚持'用证据界定责任'，并通过低成本方案（如补发配件）转化客户满意，展现了出色的风险与成本权衡能力。"
                        }
                    ],
                    potentialRisks: [
                        {
                            title: "经验深度与场景复杂性待验证",
                            description: "所有成功案例均基于实习经历，尚未经历完整产品生命周期、激烈市场竞争或大规模预算管理考验，方法论在更复杂业务下的普适性与抗压性需观察。"
                        },
                        {
                            title: "可能存在过度流程化倾向",
                            description: "极度热衷建立SOP与机制，在快速变化的电商环境中，需评估其能否在遵循流程与抓住市场突发机会之间灵活平衡，避免思维僵化。"
                        },
                        {
                            title: "战略视野与团队协作经验未显",
                            description: "聚焦于个人运营执行，对宏观市场趋势、品牌战略及跨部门协同、团队管理等方面涉及较少，若岗位要求更高阶能力，此方面为潜在短板。"
                        },
                        {
                            title: "沟通方式可能稍显强势",
                            description: "面试中多次主动引导话题，虽体现自信与准备充分，但在实际协作中需注意沟通方式，避免给同事留下过于主导或打断的印象。"
                        }
                    ]
                },
                delphiRoundtableMinutes: null,
                generateStatus: 1,
                errorMessage: null
            }
        };
    };

    /**
     * 生成节点报告 mock 数据
     * @param {string} nodeId 节点ID
     * @returns {object} 节点报告数据
     */
    const getMockNodeReport = (nodeId) => {
        // 使用传入的 nodeId，如果没有则使用 mock 数据中的第一个节点ID
        const finalNodeId = nodeId || getMockData()?.processNodes?.[0]?.id;

        // 从 interviewReportList 中查找匹配的节点报告
        const matchedReport = interviewReportList.find(
            item => String(item.nodeId) === String(finalNodeId)
        );

        if (matchedReport && matchedReport.data) {
            return {
                code: 200,
                msg: '操作成功',
                data: {
                    ...matchedReport.data,
                    nodeId: String(finalNodeId)
                }
            };
        }

        // 如果没有找到匹配的报告，返回默认数据
        return {
            code: 200,
            msg: '操作成功',
            data: {
                id: '-2013115545487138817',
                summary: null,
                suggestion: null,
                candidateRate: null,
                nodeId: String(finalNodeId),
                overallAssessment: null,
                highlights: JSON.stringify([]),
                potentialRisks: JSON.stringify([]),
                factualContext: JSON.stringify([]),
                keywords: []
            }
        };
    };

    /**
     * 生成节点AI打分 mock 数据
     * @param {string} nodeId 节点ID
     * @returns {object} 节点AI打分数据
     */
    const getMockProcessNodeAiScore = (nodeId) => {
        // 使用传入的 nodeId
        const finalNodeId = nodeId;

        // 从 processNodeAiScoreList 中查找匹配的节点AI打分数据
        const matchedScore = processNodeAiScoreList.find(
            item => String(item.nodeId) === String(finalNodeId)
        );

        if (matchedScore && matchedScore.data) {
            return {
                code: 200,
                msg: '操作成功',
                data: {
                    ...matchedScore.data,
                    id: matchedScore.data.id || String(finalNodeId)
                }
            };
        }

        // 如果没有找到匹配的数据，返回默认数据
        return {
            code: 200,
            msg: '操作成功',
            data: {
                id: String(finalNodeId),
                name: "HR面",
                comment: null,
                addEvaluations: null,
                nodeStatus: 2,
                aiResult: 2,
                assigneeId: null,
                category: 5,
                processId: null,
                prevId: null,
                abilities: [],
                expAbilities: null,
                assignee: null,
                assigneeNickname: null,
                rawChat: null,
                chat: null,
                interviewTime: null,
                actualInterviewTime: null,
                companyName: null,
                positionName: null,
                candidateName: null,
                record: null,
                conclude: null,
                aiConclusion: null,
                aiSuggestScore: null,
                score: null,
                templateId: null,
                interviewTemplateId: null,
                resumeAnalyses: null,
                expressionAnalyses: null,
                interviewInterval: null,
                taskId: null,
                audioUrl: null,
                conversationId: null,
                interviewType: 1,
                jobCategoryIdentified: null,
                diagnosedModel: null,
                hasGeneratedTemplate: 0
            }
        };
    };

    /**
     * 生成节点面试内容列表 mock 数据
     * @param {string} nodeId 节点ID
     * @returns {object} 面试内容列表数据
     */
    const getMockNodeInterviewContentList = (nodeId) => {
        if (!nodeId) {
            return {
                code: 200,
                msg: '操作成功',
                total: 0,
                rows: []
            };
        }

        // 从 interviewContentList 中查找匹配的节点对话记录
        const matchedContent = interviewContentList.find(
            item => String(item.nodeId) === String(nodeId)
        );

        if (matchedContent && matchedContent.rows) {
            // 更新每条记录的 nodeId 为传入的 nodeId
            const rows = matchedContent.rows.map(item => ({
                ...item,
                nodeId: String(nodeId)
            }));

            return {
                code: 200,
                msg: '查询成功',
                total: rows.length,
                rows: rows
            };
        }

        // 如果没有找到匹配的内容，返回空数据
        return {
            code: 200,
            msg: '查询成功',
            total: 0,
            rows: []
        };
    };

    /**
     * 生成节点问题分析AI状态 mock 数据
     * @param {string} nodeId 节点ID
     * @returns {object} 节点问题分析AI状态数据
     */
    const getMockNodeQuestionAnalysisAiStatus = (nodeId) => {
        return {
            code: 200,
            msg: '操作成功',
            data: {
                interviewerComment: 1,
                questionSuggestion: 1,
                metricsAnalysis: 1,
                questionAnalysis: 1
            }
        };
    };

    /**
     * 生成节点问题分析 mock 数据
     * @param {string} nodeId 节点ID
     * @returns {object} 节点问题分析数据
     */
    const getMockNodeQuestionAnalysis = (nodeId) => {
        // 从 nodeQuestionAnalysisList 中查找匹配的节点分析数据
        const matchedAnalysis = nodeQuestionAnalysisList.find(
            item => String(item.nodeId) === String(nodeId)
        );

        if (matchedAnalysis && matchedAnalysis.data) {
            return {
                code: 200,
                msg: '操作成功',
                data: matchedAnalysis.data
            };
        }

        // 如果没有找到匹配的数据，返回默认数据（使用第一个节点的数据）
        return {
            code: 200,
            msg: '操作成功',
            data: nodeQuestionAnalysisList[0]?.data || null
        };
    };

    return {
        enabled,
        shouldUseMock,
        mockData,
        mockCandidateRes,
        generateMockData,
        getMockData,
        getMockCandidateRes,
        insertMockDataToFirst,
        isMockData,
        clearMockData,
        setEnabled,
        getMockCandidateRank,
        getMockProcessSuggestQuestion,
        getMockProcessSummaryGenerateLatest,
        getMockNodeReport,
        getMockNodeInterviewContentList,
        getMockProcessNodeAiScore,
        getMockNodeQuestionAnalysisAiStatus,
        getMockNodeQuestionAnalysis,
    };
});

